import React from 'react';
import styled from 'styled-components';
import T from 'prop-types';
import require$$2 from 'stream';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var server_node = {exports: {}};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v16.14.0
 * react-dom-server.node.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k=objectAssign,m=React,aa=require$$2;function r(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var u="function"===typeof Symbol&&Symbol.for,ba=u?Symbol.for("react.portal"):60106,v=u?Symbol.for("react.fragment"):60107,ca=u?Symbol.for("react.strict_mode"):60108,da=u?Symbol.for("react.profiler"):60114,w=u?Symbol.for("react.provider"):60109,ea=u?Symbol.for("react.context"):60110,fa=u?Symbol.for("react.concurrent_mode"):60111,ha=u?Symbol.for("react.forward_ref"):60112,B=u?Symbol.for("react.suspense"):60113,ia=u?Symbol.for("react.suspense_list"):60120,ja=u?Symbol.for("react.memo"):60115,ka=u?Symbol.for("react.lazy"):
60116,la=u?Symbol.for("react.block"):60121,ma=u?Symbol.for("react.fundamental"):60117,na=u?Symbol.for("react.scope"):60119;function oa(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c);},function(c){0===a._status&&(a._status=2,a._result=c);});}}
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case v:return "Fragment";case ba:return "Portal";case da:return "Profiler";case ca:return "StrictMode";case B:return "Suspense";case ia:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ea:return "Context.Consumer";case w:return "Context.Provider";case ha:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ja:return C(a.type);case la:return C(a.render);case ka:if(a=1===a._status?a._result:null)return C(a)}return null}var D=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var pa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1;}
function qa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c;}else b=pa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var ra=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,sa=Object.prototype.hasOwnProperty,ta={},ua={};
function va(a){if(sa.call(ua,a))return !0;if(sa.call(ta,a))return !1;if(ra.test(a))return ua[a]=!0;ta[a]=!0;return !1}function wa(a,b,c,d){if(null!==c&&0===c.type)return !1;switch(typeof b){case "function":case "symbol":return !0;case "boolean":if(d)return !1;if(null!==c)return !c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return "data-"!==a&&"aria-"!==a;default:return !1}}
function xa(a,b,c,d){if(null===b||"undefined"===typeof b||wa(a,b,c,d))return !0;if(d)return !1;if(null!==c)switch(c.type){case 3:return !b;case 4:return !1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return !1}function J(a,b,c,d,f,h){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=h;}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1);});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1);});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1);});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1);});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1);});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1);});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1);});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1);});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0);});var ya=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return ""+a;a=""+a;var b=ya.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b;}a=f!==d?c+a.substring(f,d):c;}return a}
function za(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||xa(a,b,c,!1))return "";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return va(a)?a+'="'+(N(b)+'"'):""}function Aa(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Ba="function"===typeof Object.is?Object.is:Aa,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(r(321));return O}function Ca(){if(0<V)throw Error(r(312));return {memoizedState:null,queue:null,next:null}}function Da(){null===Q?null===P?(R=!1,P=Q=Ca()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Ca()):(R=!0,Q=Q.next);return Q}function Ea(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Fa(a,b){return "function"===typeof b?b(a):b}
function Ga(a,b,c){O=W();Q=Da();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return [d,b]}return [Q.memoizedState,b]}a=a===Fa?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ha.bind(null,O,a);return [Q.memoizedState,a]}
function Ha(a,b,c){if(!(25>V))throw Error(r(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else {for(b=c;null!==b.next;)b=b.next;b.next=a;}}function Ia(){}
var X=0,Ja={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Da();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else {for(var f=0;f<d.length&&f<b.length;f++)if(!Ba(b[f],d[f])){d=!1;break a}d=!0;}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ga,useRef:function(a){O=W();Q=Da();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Ga(Fa,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ia,useEffect:Ia,useDebugValue:Ia,useResponder:function(a,b){return {props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return [function(a){a();},!1]}},Ka={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function La(a){switch(a){case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml"}}
var Ma={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Na=k({menuitem:!0},Ma),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Oa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Oa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a];});});
var Pa=/([A-Z])/g,Qa=/^ms-/,Z=m.Children.toArray,Ra=D.ReactCurrentDispatcher,Sa={listing:!0,pre:!0,textarea:!0},Ta=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ua={},Va={};function Wa(a){if(void 0===a||null===a)return a;var b="";m.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}var Xa=Object.prototype.hasOwnProperty,Ya={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Za(a,b){if(void 0===a)throw Error(r(152,C(b)||"Component"));}
function $a(a,b,c){function d(d,h){var e=h.prototype&&h.prototype.isReactComponent,f=qa(h,b,c,e),p=[],g=!1,l={isMounted:function(){return !1},enqueueForceUpdate:function(){if(null===p)return null},enqueueReplaceState:function(a,c){g=!0;p=[c];},enqueueSetState:function(a,c){if(null===p)return null;p.push(c);}};if(e){if(e=new h(d.props,f,l),"function"===typeof h.getDerivedStateFromProps){var x=h.getDerivedStateFromProps.call(null,d.props,e.state);null!=x&&(e.state=k({},e.state,x));}}else if(O={},e=h(d.props,
f,l),e=Ea(h,d.props,e,f),null==e||null==e.render){a=e;Za(a,h);return}e.props=d.props;e.context=f;e.updater=l;l=e.state;void 0===l&&(e.state=l=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),p.length){l=p;var t=
g;p=null;g=!1;if(t&&1===l.length)e.state=l[0];else {x=t?l[0]:e.state;var y=!0;for(t=t?1:0;t<l.length;t++){var q=l[t];q="function"===typeof q?q.call(e,x,d.props,f):q;null!=q&&(y?(y=!1,x=k({},x,q)):k(x,q));}e.state=x;}}else p=null;a=e.render();Za(a,h);if("function"===typeof e.getChildContext&&(d=h.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(r(108,C(h)||"Unknown",T));}A&&(b=k({},b,A));}for(;m.isValidElement(a);){var f=a,h=f.type;if("function"!==
typeof h)break;d(f,h);}return {child:a,context:b}}
var ab=function(){function a(a,b){m.isValidElement(a)?a.type!==v?a=[a]:(a=a.props.children,a=m.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ka.html,children:a,childIndex:0,context:pa,footer:""};var c=F[0];if(0===c){var d=F;c=d.length;var p=2*c;if(!(65536>=p))throw Error(r(304));var g=new Uint16Array(p);g.set(d);F=g;F[0]=c+1;for(d=c;d<p-1;d++)F[d]=d+1;F[p-1]=0;}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[];}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a;}};b.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,h=this.threadID;E(c,h);var p=c[h];this.contextStack[b]=c;this.contextValueStack[b]=p;c[h]=a.props.value;};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f;};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a];};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Ra.current;Ra.current=Ja;try{for(var h=[""],p=!1;h[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var g=this.threadID;F[g]=F[0];F[0]=g;break}var e=this.stack[this.stack.length-1];if(p||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=h.pop();if(p){p=!1;var n=e.fallbackFrame;if(!n)throw Error(r(303));this.stack.push(n);h[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else h[this.suspenseDepth]+=G;}h[this.suspenseDepth]+=I;}else {var l=e.children[e.childIndex++],
x="";try{x+=this.render(l,e.context,e.domNamespace);}catch(t){if(null!=t&&"function"===typeof t.then)throw Error(r(294));throw t;}finally{}h.length<=this.suspenseDepth&&h.push("");h[this.suspenseDepth]+=x;}}return h[0]}finally{Ra.current=c,X=b;}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return "";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return "\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=$a(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return "";if(!m.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===ba)throw Error(r(257));throw Error(r(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return ""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ca:case fa:case da:case ia:case v:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(r(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case ha:O={};var d=c.render(a.props,a.ref);d=Ea(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return "";case ja:return a=[m.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case w:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case ea:c=a.type;d=a.props;var g=this.threadID;E(c,g);c=Z(d.children(c[g]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return "";case ma:throw Error(r(338));case ka:switch(c=a.type,oa(c),c._status){case 1:return a=[m.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(r(295));
}case na:throw Error(r(343));}throw Error(r(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();if(!Ua.hasOwnProperty(c)){if(!Ta.test(c))throw Error(r(65,c));Ua[c]=!0;}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var g=d.value;if(null==g){g=d.defaultValue;var e=d.children;if(null!=e){if(null!=
g)throw Error(r(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(r(93));e=e[0];}g=""+e;}null==g&&(g="");}d=k({},d,{value:void 0,children:""+g});}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Wa(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;g=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){g=!0;break}}else g=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:g,children:I});}}if(g=d){if(Na[c]&&(null!=g.children||null!=g.dangerouslySetInnerHTML))throw Error(r(137,c,""));if(null!=g.dangerouslySetInnerHTML){if(null!=g.children)throw Error(r(60));if(!("object"===typeof g.dangerouslySetInnerHTML&&"__html"in g.dangerouslySetInnerHTML))throw Error(r(61));}if(null!=g.style&&"object"!==typeof g.style)throw Error(r(62,""));}g=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in g)if(Xa.call(g,z)){var l=g[z];if(null!=l){if("style"===
z){n=void 0;var x="",t="";for(n in l)if(l.hasOwnProperty(n)){var y=0===n.indexOf("--"),q=l[n];if(null!=q){if(y)var A=n;else if(A=n,Va.hasOwnProperty(A))A=Va[A];else {var T=A.replace(Pa,"-$1").toLowerCase().replace(Qa,"-ms-");A=Va[A]=T;}x+=t+A+":";t=n;y=null==q||"boolean"===typeof q||""===q?"":y||"number"!==typeof q||0===q||Y.hasOwnProperty(t)&&Y[t]?(""+q).trim():q+"px";x+=y;t=";";}}l=x||null;}n=null;b:if(y=c,q=g,-1===y.indexOf("-"))y="string"===typeof q.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0;}y?Ya.hasOwnProperty(z)||(n=z,n=va(n)&&null!=l?n+'="'+(N(l)+'"'):""):n=za(z,l);n&&(G+=" "+n);}}e||I&&(G+=' data-reactroot=""');var z=G;g="";Ma.hasOwnProperty(c)?z+="/>":(z+=">",g="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null;}null!=e?(d=[],Sa.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?La(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:g});this.previousWasTextNode=!1;return z};return a}();function bb(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a;a.__proto__=b;}
var cb=function(a){function b(b,c){var d=a.call(this,{})||this;d.partialRenderer=new ab(b,c);return d}bb(b,a);var c=b.prototype;c._destroy=function(a,b){this.partialRenderer.destroy();b(a);};c._read=function(a){try{this.push(this.partialRenderer.read(a));}catch(f){this.destroy(f);}};return b}(aa.Readable),db={renderToString:function(a){a=new ab(a,!1);try{return a.read(Infinity)}finally{a.destroy();}},renderToStaticMarkup:function(a){a=new ab(a,!0);try{return a.read(Infinity)}finally{a.destroy();}},renderToNodeStream:function(a){return new cb(a,
!1)},renderToStaticNodeStream:function(a){return new cb(a,!0)},version:"16.14.0"};var reactDomServer_node_production_min=db.default||db;

{
  server_node.exports = reactDomServer_node_production_min;
}

var server = server_node.exports;

var _excluded = ["color", "size", "meaningful"];
var sizeMatrix = {
  small: 12,
  medium: 16,
  large: 24,
  xlarge: 32,
  xxlarge: 48
};
/**
 * Creates a collecticons component by passing default props to attach the
 * SVG.
 *
 * @param {function} creatorFn Function to create the collecticon. An SVG
 * should be returned.
 */

function createCollecticon(creatorFn) {
  var StyledCollecticon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var color = props.color,
        size = props.size,
        meaningful = props.meaningful,
        rest = _objectWithoutProperties(props, _excluded);

    var s = (typeof size === 'string' ? sizeMatrix[size] : size) || 16;

    var iconProps = _objectSpread2({
      width: s,
      height: s,
      fill: color || 'currentColor',
      xmlns: 'http://www.w3.org/2000/svg',
      role: 'img',
      viewBox: '0 0 16 16',
      // By default icons are rendered decoratively (aria hidden true) Using
      // "meaningful" prop (together with a descriptive title) will enable the
      // icon to be understood by assistive technologies.
      'aria-hidden': !meaningful,
      ref: ref
    }, rest);

    return creatorFn(iconProps);
  });
  StyledCollecticon.displayName = 'StyledCollecticon';
  StyledCollecticon.propTypes = {
    color: T.string,
    size: T.oneOfType([T.oneOf(['small', 'medium', 'large', 'xlarge', 'xxlarge']), T.number]),
    meaningful: T.bool
  };
  return StyledCollecticon;
}
/**
 * Creates a data URI of the given icon for use as image src.
 *
 * @param Cmp Component of the icon to render
 * @param props Props for the component
 */

var iconDataURI = function iconDataURI(Cmp) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var str = server.renderToStaticMarkup( /*#__PURE__*/React.createElement(Cmp, props));
  return "data:image/svg+xml,".concat(encodeURIComponent(str));
};

var CollecticonArea = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'area icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,12L4,13L12,13L12,12L13,12L13,4L12,4L12,3L4,3L4,4L3,4L3,12L4,12ZM7,7L9,7L9,9L7,9L7,7ZM16,12L16,16L12,16L12,15L4,15L4,16L0,16L0,12L1,12L1,4L0,4L0,0L4,0L4,1L12,1L12,0L16,0L16,4L15,4L15,12L16,12Z"
  }));
})).withConfig({
  displayName: "area__CollecticonArea",
  componentId: "sc-1hc4aeg-0"
})([""]);

var CollecticonArrowDownLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow down left icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12,12L5.414,12L15.021,2.393L13.607,0.979L4,10.586L4,4L2,4L2,14L12,14L12,12Z"
  }));
})).withConfig({
  displayName: "arrow-down-left__CollecticonArrowDownLeft",
  componentId: "sc-1f22cfq-0"
})([""]);

var CollecticonArrowDownRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow down right icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12,4L12,10.586L2.393,0.979L0.979,2.393L10.586,12L4,12L4,14L14,14L14,4L12,4Z"
  }));
})).withConfig({
  displayName: "arrow-down-right__CollecticonArrowDownRight",
  componentId: "sc-14aji5o-0"
})([""]);

var CollecticonArrowDown = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow down icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "13.586,7.586 9,12.172 9,0 7,0 7,12.172 2.414,7.586 1,9 8,16 15,9"
  }));
})).withConfig({
  displayName: "arrow-down__CollecticonArrowDown",
  componentId: "sc-1ou87kv-0"
})([""]);

var CollecticonArrowLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow left icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "8.414,13.586 3.828,9 16,9 16,7 3.828,7 8.414,2.414 7,1 0,8 7,15"
  }));
})).withConfig({
  displayName: "arrow-left__CollecticonArrowLeft",
  componentId: "sc-n1mnft-0"
})([""]);

var CollecticonArrowLoop = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow loop icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6,4H3.528c0.075-0.081,0.15-0.162,0.228-0.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8h2c0-4.419-3.581-8-8-8C5.609,0,3.466,1.047,2,2.709V0H0v6h6V4z M10,12h2.472 c-0.075,0.081-0.15,0.163-0.228,0.244C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8H0 c0,4.419,3.581,8,8,8c2.391,0,4.534-1.047,6-2.709V16h2v-6h-6V12z"
  }));
})).withConfig({
  displayName: "arrow-loop__CollecticonArrowLoop",
  componentId: "sc-1nzbdx-0"
})([""]);

var CollecticonArrowMove = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow move icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,1.924L5.773,3.651L5.061,2.939L8,0L10.939,2.939L10.227,3.651L8.5,1.924L8.5,7.5L14.076,7.5L12.349,5.773L13.061,5.061L16,8L13.061,10.939L12.349,10.227L14.076,8.5L8.5,8.5L8.5,14.076L10.227,12.349L10.939,13.061L8,16L5.061,13.061L5.773,12.349L7.5,14.076L7.5,8.5L1.924,8.5L3.651,10.227L2.939,10.939L0,8L2.939,5.061L3.651,5.773L1.924,7.5L7.5,7.5L7.5,1.924Z"
  }));
})).withConfig({
  displayName: "arrow-move__CollecticonArrowMove",
  componentId: "sc-1nwao1f-0"
})([""]);

var CollecticonArrowReply = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow reply icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,11c-0,-2.209 -1.791,-4 -4,-4c-3.548,0 -8.172,0 -8.172,0l2.586,-2.586l-1.414,-1.414l-5,5l5,5l1.414,-1.414l-2.586,-2.586l8.172,0c0.53,-0 1.039,0.211 1.414,0.586c0.375,0.375 0.586,0.884 0.586,1.414c0,1.392 0,3 0,3l2,0l0,-3Z"
  }));
})).withConfig({
  displayName: "arrow-reply__CollecticonArrowReply",
  componentId: "sc-6s0wwi-0"
})([""]);

var CollecticonArrowReturn = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow return icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.238,5.762C13.102,4.626,11.597,4,10,4H3.828l2.586-2.586L5,0L0,5l5,5l1.414-1.414L3.828,6H10 c1.063,0,2.066,0.418,2.824,1.176C13.582,7.934,14,8.937,14,10s-0.418,2.066-1.176,2.824C12.066,13.582,11.063,14,10,14H6v2h4 c1.597,0,3.102-0.626,4.238-1.762S16,11.597,16,10S15.374,6.898,14.238,5.762z"
  }));
})).withConfig({
  displayName: "arrow-return__CollecticonArrowReturn",
  componentId: "sc-1aahqvf-0"
})([""]);

var CollecticonArrowRevert = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow revert icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,0l2,0l0,2.709c1.466,-1.662 3.609,-2.709 6,-2.709c4.419,0 8,3.581 8,8c0,4.419 -3.581,8 -8,8c-4.419,0 -8,-3.581 -8,-8l2,0c0,1.603 0.624,3.11 1.756,4.244c1.132,1.134 2.641,1.756 4.244,1.756c1.603,0 3.109,-0.625 4.244,-1.756c1.131,-1.135 1.756,-2.641 1.756,-4.244c0,-1.603 -0.625,-3.109 -1.756,-4.244c-1.135,-1.131 -2.641,-1.756 -4.244,-1.756c-1.603,0 -3.109,0.625 -4.244,1.756c-0.078,0.078 -0.156,0.16 -0.228,0.244l2.472,0l0,2l-6,0l0,-6Zm10.784,4.916l1.485,1.337l-5.169,5.747l-3.244,-3.206l1.406,-1.422l1.754,1.731l3.768,-4.187Z"
  }));
})).withConfig({
  displayName: "arrow-revert__CollecticonArrowRevert",
  componentId: "sc-19w5v2z-0"
})([""]);

var CollecticonArrowRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow right icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "7.586,2.414 12.172,7 0,7 0,9 12.172,9 7.586,13.586 9,15 16,8 9,1"
  }));
})).withConfig({
  displayName: "arrow-right__CollecticonArrowRight",
  componentId: "sc-1jnuo03-0"
})([""]);

var CollecticonArrowSemiSpinCcw = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow semi spin ccw icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0,6h6V4H3.528C3.6,3.916,3.678,3.834,3.756,3.756C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8s-0.625,3.109-1.756,4.244C11.109,13.375,9.603,14,8,14v2c4.419,0,8-3.581,8-8s-3.581-8-8-8 C5.609,0,3.466,1.047,2,2.709V0L0,0z"
  }));
})).withConfig({
  displayName: "arrow-semi-spin-ccw__CollecticonArrowSemiSpinCcw",
  componentId: "sc-14rjf09-0"
})([""]);

var CollecticonArrowSemiSpinCw = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow semi spin cw icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,0v2.709C12.534,1.047,10.391,0,8,0C3.581,0,0,3.581,0,8s3.581,8,8,8v-2c-1.603,0-3.109-0.625-4.244-1.756 C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C12.322,3.834,12.4,3.916,12.472,4H10v2h6V0H14z"
  }));
})).withConfig({
  displayName: "arrow-semi-spin-cw__CollecticonArrowSemiSpinCw",
  componentId: "sc-1or7835-0"
})([""]);

var CollecticonArrowSpinCcw = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow spin ccw icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0,6h6V4H3.528C3.6,3.916,3.678,3.834,3.756,3.756C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8s-0.625,3.109-1.756,4.244C11.109,13.375,9.603,14,8,14s-3.112-0.622-4.244-1.756S2,9.603,2,8H0 c0,4.419,3.581,8,8,8s8-3.581,8-8s-3.581-8-8-8C5.609,0,3.466,1.047,2,2.709V0L0,0z"
  }));
})).withConfig({
  displayName: "arrow-spin-ccw__CollecticonArrowSpinCcw",
  componentId: "sc-15g2usu-0"
})([""]);

var CollecticonArrowSpinCw = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow spin cw icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,0v2.709C12.534,1.047,10.391,0,8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8h-2c0,1.603-0.625,3.109-1.756,4.244 S9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C12.322,3.834,12.4,3.916,12.472,4H10v2h6V0H14z"
  }));
})).withConfig({
  displayName: "arrow-spin-cw__CollecticonArrowSpinCw",
  componentId: "sc-got6vy-0"
})([""]);

var CollecticonArrowUpLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow up left icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,12L4,5.414L13.607,15.021L15.021,13.607L5.414,4L12,4L12,2L2,2L2,12L4,12Z"
  }));
})).withConfig({
  displayName: "arrow-up-left__CollecticonArrowUpLeft",
  componentId: "sc-11tv0ac-0"
})([""]);

var CollecticonArrowUpRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow up right icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,4L10.586,4L0.979,13.607L2.393,15.021L12,5.414L12,12L14,12L14,2L4,2L4,4Z"
  }));
})).withConfig({
  displayName: "arrow-up-right__CollecticonArrowUpRight",
  componentId: "sc-1c0kio-0"
})([""]);

var CollecticonArrowUp = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'arrow up icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "2.414,8.414 7,3.828 7,16 9,16 9,3.828 13.586,8.414 15,7 8,0 1,7"
  }));
})).withConfig({
  displayName: "arrow-up__CollecticonArrowUp",
  componentId: "sc-ojud5m-0"
})([""]);

var CollecticonBell = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'bell icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13,9V6.5c0-2.306-1.759-4.222-4-4.472V1.5c0-0.553-0.447-1-1-1s-1,0.447-1,1v0.528C4.759,2.278,3,4.194,3,6.5V9 c0,1.103-0.897,2-2,2v2h14v-2C13.897,11,13,10.103,13,9z M8,15.5c0.931,0,1.716-0.638,1.938-1.5H6.062 C6.284,14.862,7.069,15.5,8,15.5z"
  }));
})).withConfig({
  displayName: "bell__CollecticonBell",
  componentId: "sc-45f13-0"
})([""]);

var CollecticonBlow = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'blow icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,3c0-1.656-1.344-3-3-3S2,1.344,2,3h2c0-0.55,0.45-1,1-1s1,0.45,1,1S5.55,4,5,4H0v2h5C6.656,6,8,4.656,8,3z M12,1 C9.791,1,8,2.791,8,5v1h2V5c0-1.103,0.897-2,2-2s2,0.897,2,2s-0.897,2-2,2H1v2h11.5V8.969C14.472,8.722,16,7.041,16,5 C16,2.791,14.209,1,12,1z M9,10H2v2h7c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1H6c0,1.656,1.344,3,3,3s3-1.344,3-3S10.656,10,9,10z"
  }));
})).withConfig({
  displayName: "blow__CollecticonBlow",
  componentId: "sc-1jrq390-0"
})([""]);

var CollecticonBold = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'bold icon'), /*#__PURE__*/React.createElement("path", {
    id: "bold",
    d: "M9,1l-6,0l-0,14l6,0c2.208,0 4,-1.792 4,-4c0,-1.194 -0.524,-2.267 -1.355,-3c0.831,-0.733 1.355,-1.806 1.355,-3c-0,-2.208 -1.792,-4 -4,-4Zm-1,8c1.104,-0 2,0.896 2,2c0,1.104 -0.896,2 -2,2c-0,0 -2,0 -2,0l-0,-4l2,-0Zm0,-6c1.104,-0 2,0.896 2,2c0,1.104 -0.896,2 -2,2c-0,0 -2,0 -2,0l-0,-4l2,-0Z"
  }));
})).withConfig({
  displayName: "bold__CollecticonBold",
  componentId: "sc-19g96dt-0"
})([""]);

var CollecticonBookBookmark = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'book bookmark icon'), /*#__PURE__*/React.createElement("path", {
    d: "M5,12h9V0H9v6L7,4L5,6V0H4C2.9,0,2,0.9,2,2v12c0,1.1,0.9,2,2,2h10v-2H5c-0.6,0-1-0.4-1-1S4.4,12,5,12z"
  }));
})).withConfig({
  displayName: "book-bookmark__CollecticonBookBookmark",
  componentId: "sc-1xmlnah-0"
})([""]);

var CollecticonBook = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'book icon'), /*#__PURE__*/React.createElement("path", {
    d: "M5,12h9V0H4C2.9,0,2,0.9,2,2v12c0,1.1,0.9,2,2,2h10v-2H5c-0.6,0-1-0.4-1-1S4.4,12,5,12z M5,2h7v2H5V2z"
  }));
})).withConfig({
  displayName: "book__CollecticonBook",
  componentId: "sc-12x3af2-0"
})([""]);

var CollecticonBrandCollecticons = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand collecticons icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12.042,0h-8v2h8V0z M10.87,11.828C10.114,12.584,9.111,13,8.042,13s-2.072-0.416-2.828-1.172S4.042,10.069,4.042,9 s0.416-2.072,1.172-2.828S6.973,5,8.042,5s2.072,0.416,2.828,1.172C11.383,6.684,11.739,7.316,11.917,8h2.041 c-0.475-2.838-2.944-5-5.916-5c-3.312,0-6,2.688-6,6s2.688,6,6,6c2.972,0,5.441-2.163,5.916-5h-2.041 C11.742,10.684,11.383,11.316,10.87,11.828z"
  }));
})).withConfig({
  displayName: "brand-collecticons__CollecticonBrandCollecticons",
  componentId: "sc-egpnjr-0"
})([""]);

var CollecticonBrandDevelopmentSeed2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand development seed 2 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M9.053,13.581c-0.003-0.322,0.084-0.6,0.219-0.891c-0.288,0.253-0.403,0.541-0.506,0.931c0.028-0.456,0.25-3.45,0.25-3.6 c0.766-2.188,0.425-8.722,1.4-9.534C9.291,0.691,8.913,1.841,8.55,2.753C8.194,1.681,8.475,1,7.294,0.625 c0.944,0.8,0.756,1.491,0.95,2.594c-0.566-0.734-0.391-1.65-1.041-2.4C7.019,0.628,6.406,0.162,6.406,0.162 c0,0.028,0.491,1.009,0.581,1.528c0.091,0.519,0.306,1.556,0.275,1.938C7.341,5.747,7.875,7.8,8.241,9.878 c0.059,0.353,0.244,1.391,0.244,1.391L8.525,11.7c-0.066-0.284-0.125-0.541-0.163-0.65c-0.106-0.312-0.366-1.103-0.428-1.431 C7.044,7.787,5.416,4.2,3.241,3.669C4.475,4.763,5.803,6.206,6.1,7.6C5.437,6.669,2.831,4.681,1.772,3.956 c1.997,2.072,3.6,4.219,5.337,6.522c0.503,0.653,1.131,1.978,1.178,2.278c0.034,0.222,0.075,1.05,0.1,1.559 c-0.972-2.344-1.506-3.534-3.297-4.587C4.784,9.566,3.834,9.237,3.834,9.237c0.431,0.475,0.959,0.5,1.353,1.166 C4.372,9.869,3.525,9.775,2.594,9.744c2.991,1.547,4.606,1.978,5.616,4.95C8.291,15.181,8.169,15.55,8.178,16h0.669 c-0.003-0.316,0.003-0.616,0-0.678c0.031-0.206,0.041-0.831,0.131-1.022c0.312-0.794,0.819-1.169,1.525-1.631 C9.862,12.875,9.541,12.797,9.053,13.581z M11.997,6.578c-0.247,0.234-0.978,1.162-0.978,1.162c0.044-1.312,0.372-2.719,1.209-3.7 c-1.163,0.762-1.822,2.644-2.125,3.794c-0.119,0.463-1.497,3.144-0.856,4.584c0.125-0.525,0.422-1.038,0.75-1.487 c0.153-0.203,0.794-1.228,1.438-2.688c0.566-1.469,1.491-2.328,2.8-3.056C13.25,5.338,12.687,5.906,11.997,6.578z"
  }));
})).withConfig({
  displayName: "brand-development-seed-2__CollecticonBrandDevelopmentSeed2",
  componentId: "sc-1963e18-0"
})([""]);

var CollecticonBrandDevelopmentSeed = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand development seed icon'), /*#__PURE__*/React.createElement("path", {
    d: "M15,0H1C0.447,0,0,0.447,0,1v14c0,0.553,0.447,1,1,1h7.178c-0.009-0.45,0.113-0.819,0.031-1.306 c-1.009-2.972-2.625-3.403-5.616-4.95c0.931,0.031,1.778,0.125,2.594,0.659C4.794,9.738,4.266,9.713,3.834,9.238 c0,0,0.95,0.328,1.256,0.491c1.791,1.053,2.325,2.244,3.297,4.587c-0.025-0.509-0.066-1.337-0.1-1.559 c-0.047-0.3-0.675-1.625-1.178-2.278c-1.737-2.303-3.341-4.45-5.338-6.522C2.831,4.681,5.438,6.669,6.1,7.6 C5.803,6.206,4.475,4.763,3.241,3.669C5.416,4.2,7.044,7.788,7.934,9.619c0.062,0.328,0.322,1.119,0.428,1.431 c0.038,0.109,0.097,0.366,0.163,0.65l-0.041-0.431c0,0-0.184-1.038-0.244-1.391c-0.366-2.078-0.9-4.131-0.978-6.25 c0.031-0.381-0.184-1.419-0.275-1.938c-0.091-0.519-0.581-1.5-0.581-1.528l0,0c0,0,0.613,0.466,0.797,0.656 c0.65,0.75,0.475,1.666,1.041,2.4C8.05,2.116,8.238,1.425,7.294,0.625C8.475,1,8.194,1.681,8.55,2.753 c0.363-0.913,0.741-2.062,1.866-2.266c-0.975,0.812-0.634,7.347-1.4,9.534c0,0.15-0.222,3.144-0.25,3.6 c0.103-0.391,0.219-0.678,0.506-0.931c-0.134,0.291-0.222,0.569-0.219,0.891c0.488-0.784,0.809-0.706,1.45-0.913 c-0.706,0.462-1.212,0.837-1.525,1.631c-0.091,0.191-0.1,0.816-0.131,1.022c0.003,0.062-0.003,0.359,0,0.675H15c0.553,0,1-0.447,1-1 V1C16,0.447,15.553,0,15,0z M11.434,8.244c-0.644,1.459-1.284,2.484-1.438,2.688c-0.328,0.45-0.625,0.962-0.75,1.488 c-0.641-1.441,0.738-4.122,0.856-4.584c0.303-1.15,0.962-3.031,2.125-3.794l0,0l0,0l0,0c-0.837,0.981-1.166,2.387-1.209,3.7 c0,0,0.731-0.928,0.978-1.162c0.691-0.672,1.253-1.241,2.238-1.391C12.925,5.916,12,6.775,11.434,8.244z"
  }));
})).withConfig({
  displayName: "brand-development-seed__CollecticonBrandDevelopmentSeed",
  componentId: "sc-1d6uv5p-0"
})([""]);

var CollecticonBrandDropbox = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand dropbox icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8.011,3.76L4.005,6.317l4.005,2.557L4.005,11.43L0,8.852l4.005-2.557L0,3.76l4.005-2.557L8.011,3.76z M3.984,12.24 l4.005-2.557l4.005,2.557l-4.005,2.557L3.984,12.24z M8.011,8.852l4.005-2.557L8.011,3.76l3.984-2.557L16,3.76l-4.005,2.557 L16,8.874l-4.005,2.557L8.011,8.852z"
  }));
})).withConfig({
  displayName: "brand-dropbox__CollecticonBrandDropbox",
  componentId: "sc-1ahotra-0"
})([""]);

var CollecticonBrandFacebook = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand facebook icon'), /*#__PURE__*/React.createElement("path", {
    d: "M15.117,0H0.883C0.395,0,0,0.395,0,0.883v14.234C0,15.605,0.395,16,0.883,16h7.664V9.812H6.469V7.391h2.078V5.608 c0-2.067,1.262-3.192,3.106-3.192c0.883,0,1.642,0.066,1.863,0.095v2.16l-1.271,0.001c-1.003,0-1.197,0.477-1.197,1.176v1.543h2.398 l-0.312,2.422h-2.086V16h4.07C15.605,16,16,15.605,16,15.117V0.883C16,0.395,15.605,0,15.117,0z"
  }));
})).withConfig({
  displayName: "brand-facebook__CollecticonBrandFacebook",
  componentId: "sc-1vrmzn7-0"
})([""]);

var CollecticonBrandFlickr = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand flickr icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,8c0,1.933,1.567,3.5,3.5,3.5S7,9.933,7,8S5.433,4.5,3.5,4.5S0,6.067,0,8z M9,8c0,1.933,1.567,3.5,3.5,3.5S16,9.933,16,8 s-1.567-3.5-3.5-3.5S9,6.067,9,8z"
  }));
})).withConfig({
  displayName: "brand-flickr__CollecticonBrandFlickr",
  componentId: "sc-2bpfaz-0"
})([""]);

var CollecticonBrandGithub = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand github icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7.999,0C3.582,0,0,3.582,0,8c0,3.534,2.292,6.533,5.471,7.591 c0.4,0.073,0.546-0.174,0.546-0.386c0-0.19-0.007-0.693-0.011-1.361c-2.225,0.483-2.695-1.072-2.695-1.072 c-0.364-0.924-0.888-1.17-0.888-1.17c-0.726-0.496,0.055-0.486,0.055-0.486c0.803,0.057,1.225,0.824,1.225,0.824 c0.714,1.223,1.872,0.87,2.328,0.665c0.073-0.517,0.279-0.87,0.508-1.069c-1.776-0.202-3.644-0.888-3.644-3.954 c0-0.873,0.312-1.587,0.823-2.147C3.637,5.233,3.362,4.419,3.798,3.318c0,0,0.672-0.215,2.2,0.82C6.636,3.961,7.32,3.872,8,3.869 c0.679,0.003,1.364,0.092,2.003,0.269c1.527-1.035,2.198-0.82,2.198-0.82c0.436,1.101,0.162,1.915,0.08,2.117 c0.513,0.559,0.822,1.273,0.822,2.147c0,3.073-1.87,3.75-3.653,3.948c0.287,0.247,0.543,0.735,0.543,1.481 c0,1.069-0.01,1.932-0.01,2.195c0,0.214,0.144,0.463,0.55,0.385C13.71,14.53,16,11.534,16,8C16,3.582,12.418,0,7.999,0z"
  }));
})).withConfig({
  displayName: "brand-github__CollecticonBrandGithub",
  componentId: "sc-1i7dd0q-0"
})([""]);

var CollecticonBrandHumanRights = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand human rights icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7.734,0c0.334,0.184,1.469,0.938,1.469,2.297c0,1.203-1.941,4.791-1.188,5.722l4.812-6c0,0,1.197,1.456,0.478,2.688 c-0.747,1.281-2.588,2.781-3.325,3.897C9.524,9.294,9.746,9.663,9.746,9.663l5.834-3.194c0,0,0.469,1.391-0.641,2.391 c-1.172,1.056-3.931,1.475-3.931,2.575h4.006c0,0-0.409,1.216-1.184,1.384c-0.684,0.15-2.144-0.247-2.831,0.372 C10.271,13.847,9.456,16,7.015,16c-1.641,0-2.912-1.184-3.703-2.738c-0.913-1.797-1.938-2.663-2.991-2.881 c0,0,0.575-1.359,2.088-1.359c2.081,0,2.972,3.409,4.544,3.409c0.453,0,0.934-0.234,0.934-0.903c0-0.725-1.044-1.325-1.334-1.525 C5.862,9.522,5.309,8.756,5.665,7.472L7.734,0"
  }));
})).withConfig({
  displayName: "brand-human-rights__CollecticonBrandHumanRights",
  componentId: "sc-1pwhpak-0"
})([""]);

var CollecticonBrandId = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand id icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.462h2.518V4.963H0V14.462z M0,3.83h2.518V1.538H0V3.83z M15.756,5.599c-0.163-0.744-0.468-1.435-0.916-2.074 c-0.558-0.79-1.288-1.333-2.189-1.629c-0.529-0.174-1.192-0.267-1.988-0.279H5.124v12.845h5.538c1.942,0,3.378-0.799,4.308-2.396 C15.657,10.88,16,9.434,16,7.725C16,7.051,15.919,6.343,15.756,5.599z M12.862,10.357c-0.5,1.249-1.385,1.874-2.653,1.874H7.73 V3.847h2.479c1.222,0,2.038,0.35,2.448,1.05c0.41,0.7,0.615,1.704,0.615,3.011C13.272,8.856,13.135,9.672,12.862,10.357z"
  }));
})).withConfig({
  displayName: "brand-id__CollecticonBrandId",
  componentId: "sc-arpc4b-0"
})([""]);

var CollecticonBrandInstagram = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand instagram icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2 S9.103,10,8,10z M11,0H5C2.237,0,0,2.237,0,5v6c0,2.762,2.237,5,5,5h6c2.762,0,5-2.238,5-5V5C16,2.237,13.762,0,11,0z M14,11 c0,1.653-1.347,3-3,3H5c-1.653,0-3-1.347-3-3V5c0-1.653,1.347-3,3-3h6c1.653,0,3,1.347,3,3V11z M12,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1s1-0.447,1-1S12.553,3,12,3z"
  }));
})).withConfig({
  displayName: "brand-instagram__CollecticonBrandInstagram",
  componentId: "sc-3ob4n4-0"
})([""]);

var CollecticonBrandLastfm = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand lastfm icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3.997,12.445c2.072,0,3.059-0.972,3.059-0.972L6.469,9.88c0,0-0.953,1.062-2.381,1.062c-1.266,0-2.162-1.1-2.162-2.859 c0-2.253,1.138-3.059,2.253-3.059c1.613,0,2.125,1.044,2.566,2.381l0.588,1.831c0.588,1.778,1.688,3.206,4.856,3.206 c2.272,0,3.812-0.697,3.812-2.528c0-1.484-0.844-2.253-2.419-2.622l-1.172-0.256c-0.806-0.184-1.044-0.512-1.044-1.062 c0-0.622,0.494-0.991,1.3-0.991c0.878,0,1.356,0.331,1.428,1.119l1.831-0.219c-0.147-1.65-1.284-2.328-3.153-2.328 c-1.65,0-3.262,0.622-3.262,2.622c0,1.247,0.606,2.034,2.125,2.4l1.247,0.294c0.934,0.219,1.247,0.606,1.247,1.137 c0,0.678-0.659,0.953-1.906,0.953c-1.85,0-2.622-0.972-3.059-2.309L8.556,6.82C7.791,4.436,6.562,3.558,4.125,3.558 C1.428,3.558,0,5.261,0,8.158C0,10.942,1.428,12.445,3.997,12.445z"
  }));
})).withConfig({
  displayName: "brand-lastfm__CollecticonBrandLastfm",
  componentId: "sc-1360vss-0"
})([""]);

var CollecticonBrandLinkedin = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand linkedin icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.815,0H1.18C0.53,0,0,0.517,0,1.153v13.694C0,15.485,0.53,16,1.18,16h13.636C15.467,16,16,15.485,16,14.847V1.153 C16,0.517,15.467,0,14.815,0z M4.746,13.634H2.371V5.999h2.376V13.634z M3.559,4.955c-0.762,0-1.377-0.617-1.377-1.377 c0-0.759,0.615-1.376,1.377-1.376c0.759,0,1.376,0.617,1.376,1.376C4.935,4.339,4.319,4.955,3.559,4.955z M13.633,13.634h-2.371 V9.922c0-0.886-0.017-2.025-1.233-2.025c-1.235,0-1.423,0.964-1.423,1.96v3.778H6.235V5.999h2.274v1.043h0.033 c0.317-0.6,1.091-1.233,2.245-1.233c2.401,0,2.845,1.581,2.845,3.638V13.634z"
  }));
})).withConfig({
  displayName: "brand-linkedin__CollecticonBrandLinkedin",
  componentId: "sc-1tarsql-0"
})([""]);

var CollecticonBrandMedium = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand medium icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,0v16h16V0H0z M13.292,3.791l-0.858,0.823c-0.074,0.056-0.111,0.149-0.095,0.241v6.045 c-0.015,0.092,0.021,0.184,0.095,0.241l0.838,0.823v0.181H9.057v-0.181l0.868-0.843c0.085-0.085,0.085-0.11,0.085-0.241V5.993 l-2.414,6.13H7.271l-2.81-6.13v4.109c-0.023,0.173,0.034,0.347,0.156,0.472l1.129,1.37v0.181H2.544v-0.181l1.129-1.37 c0.121-0.125,0.175-0.3,0.146-0.472V5.351C3.832,5.219,3.781,5.089,3.683,5L2.679,3.791V3.61h3.116l2.409,5.283l2.118-5.283h2.971 V3.791z"
  }));
})).withConfig({
  displayName: "brand-medium__CollecticonBrandMedium",
  componentId: "sc-1ct5yr7-0"
})([""]);

var CollecticonBrandSatsummit = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand satsummit icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11,5L9,7V4L8,3L7,4v3L5,5H0v6h5l2-2v4h2V9l2,2h5V5H11z M2,10H1V6h1V10z M4,10H3V6h1V10z M13,10h-1V6h1V10z M15,10h-1V6h1 V10z"
  }));
})).withConfig({
  displayName: "brand-satsummit__CollecticonBrandSatsummit",
  componentId: "sc-1cwtnh8-0"
})([""]);

var CollecticonBrandSkype = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand skype icon'), /*#__PURE__*/React.createElement("path", {
    d: "M15.239,9.03c0.044-0.325,0.069-0.655,0.069-0.992c0-4.036-3.29-7.309-7.347-7.309c-0.403,0-0.799,0.033-1.183,0.096 c-0.69-0.449-1.511-0.711-2.394-0.711C1.961,0.115,0,2.078,0,4.499c0,0.881,0.259,1.7,0.706,2.387 c-0.06,0.376-0.091,0.76-0.091,1.152c0,4.037,3.288,7.309,7.346,7.309c0.458,0,0.904-0.045,1.337-0.123 c0.673,0.418,1.467,0.661,2.317,0.661c2.422,0,4.384-1.963,4.384-4.385C16,10.585,15.72,9.734,15.239,9.03z M8.648,13.425 c-2.335,0.122-3.427-0.395-4.428-1.334c-1.118-1.049-0.669-2.245,0.242-2.306c0.91-0.061,1.456,1.032,1.942,1.335 c0.485,0.303,2.331,0.993,3.306-0.122c1.062-1.213-0.706-1.841-2.002-2.031c-1.85-0.274-4.186-1.275-4.004-3.247 C3.886,3.748,5.379,2.738,6.95,2.595c2.002-0.182,3.306,0.303,4.337,1.183c1.192,1.017,0.547,2.153-0.212,2.244 C10.318,6.114,9.468,4.351,7.8,4.324C6.08,4.297,4.918,6.114,7.041,6.63c2.124,0.516,4.398,0.728,5.218,2.669 C13.078,11.241,10.985,13.303,8.648,13.425z"
  }));
})).withConfig({
  displayName: "brand-skype__CollecticonBrandSkype",
  componentId: "sc-1q1785s-0"
})([""]);

var CollecticonBrandSlack = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand slack icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.111c0,0.925,0.756,1.681,1.681,1.681c0.925,0,1.681-0.756,1.681-1.681V8.43H1.681C0.756,8.43,0,9.186,0,10.111z M16,5.889c0-0.925-0.756-1.681-1.681-1.681c-0.925,0-1.681,0.756-1.681,1.681V7.57h1.681C15.244,7.57,16,6.814,16,5.889z M10.111,7.57c0.925,0,1.681-0.756,1.681-1.681V1.681C11.792,0.756,11.036,0,10.111,0C9.186,0,8.43,0.756,8.43,1.681v4.208 C8.43,6.814,9.186,7.57,10.111,7.57z M5.889,8.43c-0.925,0-1.681,0.756-1.681,1.681v4.208C4.208,15.244,4.964,16,5.889,16 c0.925,0,1.681-0.756,1.681-1.681v-4.208C7.57,9.186,6.814,8.43,5.889,8.43z M5.889,4.208H1.681C0.756,4.208,0,4.964,0,5.889 C0,6.814,0.756,7.57,1.681,7.57h4.208c0.925,0,1.681-0.756,1.681-1.681C7.57,4.964,6.814,4.208,5.889,4.208z M5.889,0 C4.964,0,4.208,0.756,4.208,1.681c0,0.925,0.756,1.681,1.681,1.681H7.57V1.681C7.57,0.756,6.814,0,5.889,0z M14.319,8.43h-4.208 c-0.925,0-1.681,0.756-1.681,1.681c0,0.925,0.756,1.681,1.681,1.681h4.208c0.925,0,1.681-0.756,1.681-1.681 C16,9.186,15.244,8.43,14.319,8.43z M10.111,12.638H8.43v1.681C8.43,15.244,9.186,16,10.111,16c0.925,0,1.681-0.756,1.681-1.681 C11.792,13.394,11.036,12.638,10.111,12.638z"
  }));
})).withConfig({
  displayName: "brand-slack__CollecticonBrandSlack",
  componentId: "sc-1j15ji4-0"
})([""]);

var CollecticonBrandSoundcloud = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand soundcloud icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2.035,7.791c-0.05,0-0.091,0.041-0.094,0.094L1.8,9.638l0.141,1.694c0.003,0.053,0.044,0.091,0.094,0.091 c0.05,0,0.091-0.041,0.094-0.091l0.159-1.694L2.129,7.884C2.125,7.828,2.085,7.791,2.035,7.791z M2.676,7.903 c-0.056,0-0.104,0.047-0.107,0.106L2.435,9.635l0.134,1.71c0.003,0.059,0.05,0.106,0.106,0.106c0.056,0,0.103-0.047,0.106-0.106 l0.15-1.71L2.782,8.009C2.779,7.95,2.732,7.903,2.676,7.903z M3.319,6.872c-0.066,0-0.119,0.053-0.122,0.119L3.072,9.635l0.125,1.71 c0.003,0.066,0.056,0.119,0.122,0.119c0.066,0,0.119-0.053,0.122-0.119l0.141-1.71L3.441,6.99C3.435,6.922,3.382,6.872,3.319,6.872z M1.4,7.85c-0.044,0-0.075,0.034-0.081,0.078l-0.15,1.707l0.15,1.644c0.003,0.047,0.038,0.078,0.081,0.078 c0.041,0,0.075-0.034,0.081-0.078L1.65,9.635L1.482,7.928C1.475,7.881,1.444,7.85,1.4,7.85z M0.181,8.681 c-0.034,0-0.059,0.025-0.066,0.063L0,9.635l0.116,0.875c0.003,0.038,0.031,0.063,0.066,0.063c0.031,0,0.059-0.025,0.063-0.063 l0.138-0.875L0.244,8.747C0.241,8.706,0.213,8.681,0.181,8.681z M0.772,8.131c-0.034,0-0.063,0.028-0.066,0.066L0.55,9.635 l0.156,1.407c0.003,0.038,0.031,0.066,0.066,0.066c0.034,0,0.063-0.025,0.066-0.066l0.178-1.407L0.838,8.197 C0.835,8.159,0.806,8.131,0.772,8.131z M3.957,6.262c-0.072,0-0.131,0.059-0.134,0.134L3.707,9.644l0.116,1.697 c0.003,0.075,0.063,0.134,0.134,0.134c0.072,0,0.131-0.059,0.134-0.134l0.131-1.697L4.091,6.397 C4.088,6.318,4.029,6.262,3.957,6.262z M7.405,5.403C7.373,5.381,7.333,5.368,7.292,5.368S7.214,5.381,7.183,5.402 c-0.056,0.038-0.094,0.1-0.094,0.169v0.038L7.014,9.635c0,0.003,0.078,1.635,0.078,1.635c0,0.003,0,0.003,0,0.006 c0.003,0.047,0.019,0.088,0.047,0.122c0.038,0.044,0.094,0.075,0.156,0.075c0.056,0,0.106-0.022,0.141-0.059 c0.038-0.038,0.059-0.088,0.063-0.144l0.009-0.163l0.078-1.469L7.501,5.571C7.492,5.5,7.458,5.44,7.405,5.403z M14.034,7.537 c-0.269,0-0.528,0.053-0.763,0.153c-0.156-1.775-1.644-3.166-3.46-3.166c-0.444,0-0.878,0.088-1.26,0.234 C8.402,4.815,8.364,4.874,8.361,4.99v6.248c0.003,0.122,0.094,0.216,0.213,0.225c0.006,0,5.457,0,5.457,0 c1.088,0,1.969-0.872,1.969-1.96C16.003,8.419,15.122,7.537,14.034,7.537z M6.617,6.031c-0.103,0-0.188,0.084-0.191,0.188 L6.342,9.635l0.084,1.644c0.003,0.103,0.084,0.188,0.191,0.188c0.103,0,0.188-0.081,0.191-0.188l0.094-1.644L6.808,6.218 C6.804,6.112,6.72,6.031,6.617,6.031z M8.073,5.018C8.042,4.999,8.005,4.987,7.964,4.987c-0.053,0-0.1,0.019-0.138,0.05 c-0.047,0.041-0.078,0.1-0.081,0.166v0.022L7.658,9.638l0.044,0.816l0.044,0.794c0,0.119,0.1,0.216,0.216,0.216 c0.119,0,0.216-0.097,0.216-0.216v0.003l0.097-1.61L8.177,5.206C8.18,5.124,8.136,5.056,8.073,5.018z M5.948,5.915 c-0.097,0-0.175,0.078-0.175,0.175L5.679,9.635l0.094,1.653c0.003,0.097,0.078,0.175,0.175,0.175s0.172-0.078,0.175-0.175 l0.103-1.653L6.123,6.087C6.12,5.99,6.042,5.915,5.948,5.915z M5.282,5.834c-0.088,0-0.159,0.072-0.163,0.163l-0.1,3.638l0.1,1.669 c0.003,0.091,0.075,0.159,0.163,0.159s0.159-0.072,0.163-0.159l0.113-1.669L5.445,5.996C5.442,5.906,5.37,5.834,5.282,5.834z M4.623,5.968c-0.081,0-0.147,0.066-0.15,0.147l-0.11,3.52l0.109,1.682c0.003,0.081,0.069,0.147,0.15,0.147s0.144-0.066,0.15-0.147 l0.122-1.682l-0.121-3.52C4.767,6.031,4.701,5.968,4.623,5.968z"
  }));
})).withConfig({
  displayName: "brand-soundcloud__CollecticonBrandSoundcloud",
  componentId: "sc-1sstkof-0"
})([""]);

var CollecticonBrandTumblr = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand tumblr icon'), /*#__PURE__*/React.createElement("path", {
    d: "M9.707,15.997c-3.396,0-4.687-2.503-4.687-4.274V6.496H3.412V4.43c2.418-0.875,3.009-3.062,3.14-4.312 C6.561,0.034,6.63,0,6.667,0h2.343v4.074h3.199v2.421H8.995v4.98c0.009,0.669,0.25,1.581,1.472,1.581h0.059 c0.422-0.012,0.99-0.137,1.29-0.278l0.772,2.284c-0.291,0.425-1.6,0.915-2.771,0.937H9.698C9.698,15.997,9.707,15.997,9.707,15.997z"
  }));
})).withConfig({
  displayName: "brand-tumblr__CollecticonBrandTumblr",
  componentId: "sc-2ls7o1-0"
})([""]);

var CollecticonBrandTwitter = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand twitter icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,3.038c-0.589,0.261-1.221,0.438-1.885,0.517c0.678-0.406,1.198-1.05,1.443-1.816c-0.634,0.376-1.337,0.649-2.085,0.797 c-0.599-0.638-1.452-1.037-2.396-1.037c-1.813,0-3.283,1.47-3.283,3.282c0,0.257,0.029,0.508,0.085,0.748 c-2.728-0.137-5.147-1.444-6.766-3.43C0.831,2.584,0.669,3.148,0.669,3.75c0,1.139,0.579,2.144,1.46,2.732 C1.592,6.465,1.086,6.317,0.643,6.071c0,0.014,0,0.027,0,0.041c0,1.59,1.132,2.917,2.633,3.219C3,9.406,2.71,9.447,2.411,9.447 c-0.212,0-0.417-0.021-0.618-0.059c0.418,1.304,1.63,2.253,3.066,2.28c-1.123,0.88-2.539,1.405-4.077,1.405 c-0.265,0-0.526-0.016-0.783-0.046c1.453,0.931,3.178,1.475,5.032,1.475c6.038,0,9.34-5.002,9.34-9.34 c0-0.142-0.003-0.284-0.01-0.425C15.003,4.274,15.56,3.696,16,3.038z"
  }));
})).withConfig({
  displayName: "brand-twitter__CollecticonBrandTwitter",
  componentId: "sc-1joz4pi-0"
})([""]);

var CollecticonBrandYoutube = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'brand youtube icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6.364,10.379L6.364,5.621L10.545,8L6.364,10.379ZM15.666,4.124C15.482,3.431 14.939,2.885 14.251,2.7C13.003,2.364 8,2.364 8,2.364C8,2.364 2.997,2.364 1.749,2.7C1.061,2.885 0.518,3.431 0.334,4.124C0,5.38 0,8 0,8C0,8 0,10.62 0.334,11.876C0.518,12.569 1.061,13.115 1.749,13.3C2.997,13.636 8,13.636 8,13.636C8,13.636 13.003,13.636 14.251,13.3C14.939,13.115 15.482,12.569 15.666,11.876C16,10.62 16,8 16,8C16,8 16,5.38 15.666,4.124"
  }));
})).withConfig({
  displayName: "brand-youtube__CollecticonBrandYoutube",
  componentId: "sc-sr8y6n-0"
})([""]);

var CollecticonBriefcase = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'briefcase icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6,2h4v1h2V2c0-1.1-0.9-2-2-2H6C4.9,0,4,0.9,4,2v1h2V2z M0,14c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1V8H0V14z M7,9h2v1 c0,0.553-0.447,1-1,1s-1-0.447-1-1V9z M15,4H1C0.45,4,0,4.45,0,5v2h16V5C16,4.45,15.55,4,15,4z"
  }));
})).withConfig({
  displayName: "briefcase__CollecticonBriefcase",
  componentId: "sc-kf8guy-0"
})([""]);

var CollecticonCalendarRange = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'calendar range icon'), /*#__PURE__*/React.createElement("path", {
    id: "calendar-range",
    d: "M15,15L1,15C0.447,15 0,14.553 0,14L0,3C0,2.447 0.447,2 1,2L2,2L2,4L5,4L5,2L11,2L11,4L14,4L14,2L15,2C15.553,2 16,2.447 16,3L16,14C16,14.553 15.553,15 15,15ZM14,6L2,6L2,13L14,13L14,6ZM9,12L7,12L7,10L9,10L9,12ZM6,12L4,12L4,10L6,10L6,12ZM12,9L10,9L10,7L12,7L12,9ZM9,9L7,9L7,7L9,7L9,9ZM4,3L3,3L3,0.494C3,0.222 3.222,0 3.497,0L3.506,0C3.778,0 4,0.222 4,0.494L4,3ZM13,3L12,3L12,0.494C12,0.222 12.222,0 12.497,0L12.506,0C12.778,0 13,0.222 13,0.494L13,3Z"
  }));
})).withConfig({
  displayName: "calendar-range__CollecticonCalendarRange",
  componentId: "sc-d7veqq-0"
})([""]);

var CollecticonCalendarSlot = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'calendar slot icon'), /*#__PURE__*/React.createElement("path", {
    id: "calendar-day",
    d: "M6,7L4,7L4,9L6,9L6,7ZM15,2L14,2L14,4L11,4L11,2L5,2L5,4L2,4L2,2L1,2C0.447,2 0,2.447 0,3L0,14C0,14.553 0.447,15 1,15L15,15C15.553,15 16,14.553 16,14L16,3C16,2.447 15.553,2 15,2ZM14,13L2,13L2,6L14,6L14,13ZM4,0.494C4,0.222 3.778,0 3.506,0L3.497,0C3.222,0 3,0.222 3,0.494L3,3L4,3L4,0.494ZM13,0.494C13,0.222 12.778,0 12.506,0L12.497,0C12.222,0 12,0.222 12,0.494L12,3L13,3L13,0.494Z"
  }));
})).withConfig({
  displayName: "calendar-slot__CollecticonCalendarSlot",
  componentId: "sc-149d7hp-0"
})([""]);

var CollecticonCalendar = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'calendar icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6,7H4v2h2V7z M6,10H4v2h2V10z M9,7H7v2h2V7z M9,10H7v2h2V10z M12,7h-2v2h2V7z M12,10h-2v2h2V10z M15,2h-1v2h-3V2H5v2H2V2H1 C0.447,2,0,2.447,0,3v11c0,0.553,0.447,1,1,1h14c0.553,0,1-0.447,1-1V3C16,2.447,15.553,2,15,2z M14,13H2V6h12V13z M4,0.494 C4,0.222,3.778,0,3.506,0H3.497C3.222,0,3,0.222,3,0.494V3h1V0.494z M13,0.494C13,0.222,12.778,0,12.506,0h-0.009 C12.222,0,12,0.222,12,0.494V3h1V0.494z"
  }));
})).withConfig({
  displayName: "calendar__CollecticonCalendar",
  componentId: "sc-8vlmvg-0"
})([""]);

var CollecticonCamera = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'camera icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6,8.5c0,1.103,0.897,2,2,2s2-0.897,2-2s-0.897-2-2-2S6,7.397,6,8.5z M15,3h-3.5C11.25,2,11,1,10,1H6C5,1,4.75,2,4.5,3H1 C0.45,3,0,3.45,0,4v9c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1V4C16,3.45,15.55,3,15,3z M8,12.5c-2.209,0-4-1.791-4-4s1.791-4,4-4 s4,1.791,4,4S10.209,12.5,8,12.5z"
  }));
})).withConfig({
  displayName: "camera__CollecticonCamera",
  componentId: "sc-1o7mf61-0"
})([""]);

var CollecticonChartBars = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chart bars icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,14L16,16L0,16L0,14L16,14ZM11,5L11,13L9,13L9,5L11,5ZM15,1L15,13L13,13L13,1L15,1ZM3,9L3,13L1,13L1,9L3,9ZM7,3L7,13L5,13L5,3L7,3Z"
  }));
})).withConfig({
  displayName: "chart-bars__CollecticonChartBars",
  componentId: "sc-uuv0u5-0"
})([""]);

var CollecticonChartLine = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chart line icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,14L16,16L0,16L0,14L16,14ZM13.292,4.39C13.109,4.141 13,3.833 13,3.5C13,2.672 13.672,2 14.5,2C15.328,2 16,2.672 16,3.5C16,4.328 15.328,5 14.5,5C14.483,5 14.466,5 14.448,4.999L10.708,10.61C10.891,10.859 11,11.167 11,11.5C11,12.328 10.328,13 9.5,13C8.672,13 8,12.328 8,11.5C8,11.193 8.092,10.907 8.251,10.67L5.626,6.995C5.584,6.998 5.542,7 5.5,7C5.458,7 5.416,6.998 5.374,6.995L2.749,10.67C2.908,10.907 3,11.193 3,11.5C3,12.328 2.328,13 1.5,13C0.672,13 0,12.328 0,11.5C0,10.672 0.672,10 1.5,10C1.542,10 1.584,10.002 1.626,10.005L4.251,6.33C4.092,6.093 4,5.807 4,5.5C4,4.672 4.672,4 5.5,4C6.328,4 7,4.672 7,5.5C7,5.807 6.908,6.093 6.749,6.33L9.374,10.005C9.416,10.002 9.458,10 9.5,10C9.517,10 9.534,10 9.552,10.001L13.292,4.39Z"
  }));
})).withConfig({
  displayName: "chart-line__CollecticonChartLine",
  componentId: "sc-ct4my2-0"
})([""]);

var CollecticonChartPie = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chart pie icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7,9L14,9C13.95,12.913 10.833,16 7,16C3.137,16 0,12.863 0,9C0,5.137 3.137,2 7,2L7,9ZM16,7L9,7L9,0L10.41,0.142C13.576,0.793 15.962,3.577 16,7Z"
  }));
})).withConfig({
  displayName: "chart-pie__CollecticonChartPie",
  componentId: "sc-10flqng-0"
})([""]);

var CollecticonChevronDownSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron down small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "12.586,4.586 8,9.172 3.414,4.586 2,6 8,12 14,6"
  }));
})).withConfig({
  displayName: "chevron-down--small__CollecticonChevronDownSmall",
  componentId: "sc-j16u51-0"
})([""]);

var CollecticonChevronDownTrailSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron down trail small icon'), /*#__PURE__*/React.createElement("g", {
    id: "chevron-down-trail--small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-a100",
    d: "M12.586,6.586l-4.586,4.586l-4.586,-4.586l-1.414,1.414l6,6l6,-6l-1.414,-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-a32",
    d: "M12.586,1.586l-4.586,4.586l-4.586,-4.586l-1.414,1.414l6,6l6,-6l-1.414,-1.414Z",
    opacity: "0.32"
  })));
})).withConfig({
  displayName: "chevron-down-trail--small__CollecticonChevronDownTrailSmall",
  componentId: "sc-1ga8kui-0"
})([""]);

var CollecticonChevronDown = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron down icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "14.586,3.586 8,10.172 1.414,3.586 0,5 8,13 16,5"
  }));
})).withConfig({
  displayName: "chevron-down__CollecticonChevronDown",
  componentId: "sc-16oe913-0"
})([""]);

var CollecticonChevronLeftSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron left small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "11.414,12.586 6.828,8 11.414,3.414 10,2 4,8 10,14"
  }));
})).withConfig({
  displayName: "chevron-left--small__CollecticonChevronLeftSmall",
  componentId: "sc-18vjqa1-0"
})([""]);

var CollecticonChevronLeftTrailSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron left trail small icon'), /*#__PURE__*/React.createElement("g", {
    id: "chevron-left-trail--small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-a32",
    d: "M14.414,12.586l-4.586,-4.586l4.586,-4.586l-1.414,-1.414l-6,6l6,6l1.414,-1.414Z",
    opacity: "0.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-a100",
    d: "M9.414,12.586l-4.586,-4.586l4.586,-4.586l-1.414,-1.414l-6,6l6,6l1.414,-1.414Z"
  })));
})).withConfig({
  displayName: "chevron-left-trail--small__CollecticonChevronLeftTrailSmall",
  componentId: "sc-r4sk2v-0"
})([""]);

var CollecticonChevronLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron left icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "12.414,14.586 5.828,8 12.414,1.414 11,0 3,8 11,16 "
  }));
})).withConfig({
  displayName: "chevron-left__CollecticonChevronLeft",
  componentId: "sc-o6152v-0"
})([""]);

var CollecticonChevronRightSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron right small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "4.586,3.414 9.172,8 4.586,12.586 6,14 12,8 6,2"
  }));
})).withConfig({
  displayName: "chevron-right--small__CollecticonChevronRightSmall",
  componentId: "sc-1oue0hw-0"
})([""]);

var CollecticonChevronRightTrailSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron right trail small icon'), /*#__PURE__*/React.createElement("g", {
    id: "chevron-right-trail--small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-a100",
    d: "M6.586,3.414l4.586,4.586l-4.586,4.586l1.414,1.414l6,-6l-6,-6l-1.414,1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-a32",
    d: "M1.586,3.414l4.586,4.586l-4.586,4.586l1.414,1.414l6,-6l-6,-6l-1.414,1.414Z",
    opacity: "0.32"
  })));
})).withConfig({
  displayName: "chevron-right-trail--small__CollecticonChevronRightTrailSmall",
  componentId: "sc-cr3ier-0"
})([""]);

var CollecticonChevronRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron right icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "3.586,1.414 10.172,8 3.586,14.586 5,16 13,8 5,0"
  }));
})).withConfig({
  displayName: "chevron-right__CollecticonChevronRight",
  componentId: "sc-138s8d2-0"
})([""]);

var CollecticonChevronStepBackward = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron step backward icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2,15h2V1H2V15z M14.4,2.4L13,1L6,8l7,7l1.4-1.4L8.8,8L14.4,2.4z"
  }));
})).withConfig({
  displayName: "chevron-step-backward__CollecticonChevronStepBackward",
  componentId: "sc-1h8m6i3-0"
})([""]);

var CollecticonChevronStepForward = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron step forward icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,1h-2v14h2V1z M7.2,8l-5.6,5.6L3,15l7-7L3,1L1.6,2.4L7.2,8z"
  }));
})).withConfig({
  displayName: "chevron-step-forward__CollecticonChevronStepForward",
  componentId: "sc-ymfau8-0"
})([""]);

var CollecticonChevronUpSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron up small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "3.414,11.414 8,6.828 12.586,11.414 14,10 8,4 2,10"
  }));
})).withConfig({
  displayName: "chevron-up--small__CollecticonChevronUpSmall",
  componentId: "sc-1vuskgk-0"
})([""]);

var CollecticonChevronUpTrailSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron up trail small icon'), /*#__PURE__*/React.createElement("g", {
    id: "chevron-up-trail--small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-a32",
    d: "M3.414,14.414l4.586,-4.586l4.586,4.586l1.414,-1.414l-6,-6l-6,6l1.414,1.414Z",
    opacity: "0.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-a100",
    d: "M3.414,9.414l4.586,-4.586l4.586,4.586l1.414,-1.414l-6,-6l-6,6l1.414,1.414Z"
  })));
})).withConfig({
  displayName: "chevron-up-trail--small__CollecticonChevronUpTrailSmall",
  componentId: "sc-1u82jsn-0"
})([""]);

var CollecticonChevronUp = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'chevron up icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "1.414,12.414 8,5.828 14.586,12.414 16,11 8,3 0,11"
  }));
})).withConfig({
  displayName: "chevron-up__CollecticonChevronUp",
  componentId: "sc-ks5tuk-0"
})([""]);

var CollecticonCircleExclamation = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle exclamation icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7,9h2V4H7V9z M9,11c0-0.553-0.447-1-1-1s-1,0.447-1,1s0.447,1,1,1S9,11.553,9,11z M16,8c0-4.419-3.581-8-8-8S0,3.581,0,8 s3.581,8,8,8S16,12.419,16,8z M14,8c0,1.603-0.625,3.109-1.756,4.244C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756 C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8z"
  }));
})).withConfig({
  displayName: "circle-exclamation__CollecticonCircleExclamation",
  componentId: "sc-1k0psd0-0"
})([""]);

var CollecticonCircleForbidden = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle forbidden icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,8c0,4.419,3.581,8,8,8s8-3.581,8-8s-3.581-8-8-8S0,3.581,0,8z M12.891,11.478L4.522,3.109C5.531,2.391,6.734,2,8,2 c1.603,0,3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8C14,9.266,13.609,10.469,12.891,11.478z M2,8 c0-1.266,0.391-2.469,1.109-3.478l8.369,8.369C10.469,13.609,9.266,14,8,14c-1.603,0-3.109-0.625-4.244-1.756 C2.625,11.109,2,9.603,2,8z"
  }));
})).withConfig({
  displayName: "circle-forbidden__CollecticonCircleForbidden",
  componentId: "sc-1o35ffe-0"
})([""]);

var CollecticonCircleInformation = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle information icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7,12h2V7H7V12z M8,4C7.448,4,7,4.448,7,5s0.448,1,1,1c0.552,0,1-0.448,1-1S8.552,4,8,4z M8,0C3.582,0,0,3.582,0,8 c0,4.418,3.582,8,8,8s8-3.582,8-8C16,3.582,12.418,0,8,0z M12.243,12.243C11.109,13.376,9.603,14,8,14s-3.109-0.624-4.243-1.757 C2.624,11.109,2,9.603,2,8s0.624-3.109,1.757-4.243C4.891,2.624,6.397,2,8,2s3.109,0.624,4.243,1.757C13.376,4.891,14,6.397,14,8 C14,9.603,13.376,11.109,12.243,12.243z"
  }));
})).withConfig({
  displayName: "circle-information__CollecticonCircleInformation",
  componentId: "sc-17lqoff-0"
})([""]);

var CollecticonCirclePause = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle pause icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.109,13.375,9.603,14,8,14 s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8c0-1.603,0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8C14,9.603,13.375,11.109,12.244,12.244z M5,11h2V5H5V11z M9,11h2V5H9V11z"
  }));
})).withConfig({
  displayName: "circle-pause__CollecticonCirclePause",
  componentId: "sc-kbggwr-0"
})([""]);

var CollecticonCirclePlayNext = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle play next icon'), /*#__PURE__*/React.createElement("path", {
    d: "M5,11l4-3L5,5V11z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8c0-1.603,0.625-3.109,1.756-4.244 C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8C14,9.603,13.375,11.109,12.244,12.244z M9,8v3h2V5H9 V8z"
  }));
})).withConfig({
  displayName: "circle-play-next__CollecticonCirclePlayNext",
  componentId: "sc-ha7um8-0"
})([""]);

var CollecticonCirclePlay = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle play icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6,12l6-4L6,4V12z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z"
  }));
})).withConfig({
  displayName: "circle-play__CollecticonCirclePlay",
  componentId: "sc-15udb8c-0"
})([""]);

var CollecticonCircleQuestion = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle question icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.5c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1C9,10.948,8.552,10.5,8,10.5z M8,0 C3.582,0,0,3.582,0,8c0,4.418,3.582,8,8,8s8-3.582,8-8C16,3.582,12.418,0,8,0z M12.243,12.243C11.109,13.376,9.603,14,8,14 s-3.109-0.624-4.243-1.757C2.624,11.109,2,9.603,2,8s0.624-3.109,1.757-4.243C4.891,2.624,6.397,2,8,2s3.109,0.624,4.243,1.757 C13.376,4.891,14,6.397,14,8C14,9.603,13.376,11.109,12.243,12.243z M7.927,3.755c-2.248,0-2.76,1.695-2.802,2.906h1.571 c0.028-0.256,0.101-1.418,1.221-1.418c0.672,0,1.206,0.406,1.206,1.175c0,0.695-0.724,1.155-1.303,1.711 C7.241,8.685,7.168,9.325,7.168,9.824V10c0.146,0,1.615,0,1.615,0V9.824c0-1.256,1.967-1.594,1.967-3.541 C10.75,5.059,9.874,3.755,7.927,3.755z"
  }));
})).withConfig({
  displayName: "circle-question__CollecticonCircleQuestion",
  componentId: "sc-1tmmqtp-0"
})([""]);

var CollecticonCircleRecord = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle record icon'), /*#__PURE__*/React.createElement("path", {
    id: "circle-record",
    d: "M8,0.035C12.406,0.035 15.983,3.612 15.983,8.017C15.983,12.423 12.406,16 8,16C3.594,16 0.017,12.423 0.017,8.017C0.017,3.612 3.594,0.035 8,0.035ZM8,2.035C4.698,2.035 2.017,4.716 2.017,8.017C2.017,11.319 4.698,14 8,14C11.302,14 13.983,11.319 13.983,8.017C13.983,4.716 11.302,2.035 8,2.035ZM7.989,5.017C9.636,5.017 10.972,6.354 10.972,8C10.972,9.646 9.636,10.983 7.989,10.983C6.343,10.983 5.007,9.646 5.007,8C5.007,6.354 6.343,5.017 7.989,5.017Z"
  }));
})).withConfig({
  displayName: "circle-record__CollecticonCircleRecord",
  componentId: "sc-dorv0a-0"
})([""]);

var CollecticonCircleStop = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle stop icon'), /*#__PURE__*/React.createElement("path", {
    d: "M5,11h6V5H5V11z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z"
  }));
})).withConfig({
  displayName: "circle-stop__CollecticonCircleStop",
  componentId: "sc-p4y1fg-0"
})([""]);

var CollecticonCircleTick = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle tick icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.109,13.375,9.603,14,8,14 s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z M10.784,4.916L7.016,9.103L5.262,7.372L3.856,8.794L7.1,12l5.169-5.747 L10.784,4.916z"
  }));
})).withConfig({
  displayName: "circle-tick__CollecticonCircleTick",
  componentId: "sc-ucs8qm-0"
})([""]);

var CollecticonCircleXmark = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'circle xmark icon'), /*#__PURE__*/React.createElement("path", {
    d: "M10.294,4.294L8,6.584L5.706,4.291L4.291,5.706L6.584,8l-2.294,2.294l1.416,1.416L8,9.416l2.294,2.294l1.416-1.416L9.416,8 l2.294-2.294L10.294,4.294z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z"
  }));
})).withConfig({
  displayName: "circle-xmark__CollecticonCircleXmark",
  componentId: "sc-1rxb9gg-0"
})([""]);

var CollecticonClipboardTick = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'clipboard tick icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11,2c0-0.6-0.4-1-1-1H9.4C9.2,0.4,8.7,0,8,0S6.8,0.4,6.6,1H6C5.4,1,5,1.4,5,2v2h6V2z M13,2h-1v2h1v10H3V4h1V2H3 C1.9,2,1,2.9,1,4v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V4C15,2.9,14.1,2,13,2z M7,9.7L5.2,8L3.8,9.4L7,12.6l5.2-5.7l-1.5-1.3L7,9.7 z"
  }));
})).withConfig({
  displayName: "clipboard-tick__CollecticonClipboardTick",
  componentId: "sc-1pdrcx1-0"
})([""]);

var CollecticonClipboard = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'clipboard icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11,6H5v2h6V6z M11,2c0-0.6-0.4-1-1-1H9.4C9.2,0.4,8.7,0,8,0S6.8,0.4,6.6,1H6C5.4,1,5,1.4,5,2v2h6V2z M11,10H5v2h6V10z M13,2h-1v2h1v10H3V4h1V2H3C1.9,2,1,2.9,1,4v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V4C15,2.9,14.1,2,13,2z"
  }));
})).withConfig({
  displayName: "clipboard__CollecticonClipboard",
  componentId: "sc-a2zain-0"
})([""]);

var CollecticonClockBack = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'clock back icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C5.609,0,3.463,1.047,2,2.709V0H0v6h6V4H3.528C3.6,3.916,3.681,3.838,3.756,3.756 C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8s-0.625,3.109-1.756,4.244 C11.109,13.375,9.603,14,8,14s-3.113-0.619-4.244-1.756S2,9.603,2,8H0c0,4.419,3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M7,4v4.416 l3.291,3.291l1.416-1.416L9,7.584V4H7z"
  }));
})).withConfig({
  displayName: "clock-back__CollecticonClockBack",
  componentId: "sc-rxii24-0"
})([""]);

var CollecticonClock = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'clock icon'), /*#__PURE__*/React.createElement("path", {
    d: "M9,4H7v4.416l3.294,3.291l1.413-1.416L9,7.584V4z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M8,14 c-3.312,0-6-2.688-6-6s2.688-6,6-6s6,2.688,6,6S11.312,14,8,14z"
  }));
})).withConfig({
  displayName: "clock__CollecticonClock",
  componentId: "sc-183mh7f-0"
})([""]);

var CollecticonCode = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'code icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12.294,3.294l-1.416,1.416L13.5,8l-2.622,3.294l1.416,1.416L16,8L12.294,3.294z M5.122,4.706L3.706,3.291L0,8l3.706,4.706 l1.416-1.416L2.5,8L5.122,4.706z M6,13h2l2-10H8L6,13z"
  }));
})).withConfig({
  displayName: "code__CollecticonCode",
  componentId: "sc-i0rakm-0"
})([""]);

var CollecticonCog = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'cog icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,9V7l-2.259-0.753c-0.113-0.372-0.262-0.728-0.441-1.066l1.066-2.131L12.95,1.634L10.819,2.7 c-0.338-0.178-0.694-0.325-1.066-0.441L9,0H7L6.247,2.259C5.875,2.372,5.519,2.522,5.181,2.7L3.05,1.638L1.638,3.05l1.066,2.131 C2.522,5.519,2.375,5.875,2.259,6.247L0,7v2l2.259,0.753c0.112,0.372,0.263,0.728,0.441,1.066L1.634,12.95l1.416,1.416L5.181,13.3 c0.338,0.178,0.694,0.328,1.066,0.441L7,16h2l0.753-2.259c0.372-0.113,0.728-0.262,1.066-0.441l2.131,1.066l1.416-1.416L13.3,10.819 c0.178-0.337,0.328-0.694,0.441-1.066L16,9z M8,11c-1.656,0-3-1.344-3-3s1.344-3,3-3s3,1.344,3,3S9.656,11,8,11z"
  }));
})).withConfig({
  displayName: "cog__CollecticonCog",
  componentId: "sc-1sd7ai6-0"
})([""]);

var CollecticonCompass2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'compass 2 icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "15,1 1,6 8,8 10,15"
  }));
})).withConfig({
  displayName: "compass-2__CollecticonCompass2",
  componentId: "sc-1tbgltj-0"
})([""]);

var CollecticonCompass = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'compass icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M8,14c-3.312,0-6-2.688-6-6s2.688-6,6-6s6,2.688,6,6 S11.312,14,8,14z M6.5,6.5L4,11v1h1l4.5-2.5L12,5V4h-1L6.5,6.5z M8,9C7.447,9,7,8.553,7,8s0.447-1,1-1s1,0.447,1,1S8.553,9,8,9z"
  }));
})).withConfig({
  displayName: "compass__CollecticonCompass",
  componentId: "sc-1ka5acc-0"
})([""]);

var CollecticonCrosshair2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'crosshair 2 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.35,13.137,10.225,13.716,9,13.919V11H7 v2.919c-1.222-0.203-2.35-0.781-3.244-1.675C2.862,11.35,2.287,10.222,2.081,9H5V7H2.081c0.203-1.222,0.781-2.35,1.675-3.244 S5.775,2.284,7,2.081V5h2V2.081c1.222,0.203,2.35,0.781,3.244,1.675C13.137,4.65,13.716,5.775,13.919,7H11v2h2.919 C13.712,10.222,13.137,11.35,12.244,12.244z"
  }));
})).withConfig({
  displayName: "crosshair-2__CollecticonCrosshair2",
  componentId: "sc-6nf0hc-0"
})([""]);

var CollecticonCrosshair = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'crosshair icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13.916,7C13.494,4.488,11.512,2.506,9,2.084V0H7v2.084C4.488,2.506,2.506,4.488,2.084,7H0v2h2.084 C2.506,11.512,4.488,13.494,7,13.916V16h2v-2.084c2.512-0.422,4.494-2.403,4.916-4.916H16V7H13.916z M10.828,10.828 C10.072,11.584,9.069,12,8,12s-2.072-0.416-2.828-1.172S4,9.069,4,8s0.416-2.072,1.172-2.828S6.931,4,8,4s2.072,0.416,2.828,1.172 S12,6.931,12,8S11.584,10.072,10.828,10.828z M8,6C6.897,6,6,6.897,6,8s0.897,2,2,2s2-0.897,2-2S9.103,6,8,6z"
  }));
})).withConfig({
  displayName: "crosshair__CollecticonCrosshair",
  componentId: "sc-1amsdvw-0"
})([""]);

var CollecticonDiscDollar = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'disc dollar icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12,6H6.181C5.909,6,5.688,6.222,5.688,6.494v0.009 c0,0.272,0.222,0.494,0.494,0.494H10c1.103,0,2,0.897,2,2v1c0,1.103-0.897,2-2,2H9v1H7v-1H4v-2h5.506C9.778,9.997,10,9.775,10,9.503 V9.494C10,9.222,9.778,9,9.506,9H6H5.981C4.887,9,4,8.112,4,7.019V6c0-1.103,0.897-2,2-2h1V3h2v1h3V6z"
  }));
})).withConfig({
  displayName: "disc-dollar__CollecticonDiscDollar",
  componentId: "sc-1dlkh66-0"
})([""]);

var CollecticonDiscXmark = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'disc xmark icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.582,0,0,3.582,0,8s3.582,8,8,8s8-3.582,8-8S12.418,0,8,0z M12.707,11.293l-1.414,1.414L8,9.414l-3.293,3.293 l-1.414-1.414L6.586,8L3.293,4.707l1.414-1.414L8,6.586l3.293-3.293l1.414,1.414L9.414,8L12.707,11.293z"
  }));
})).withConfig({
  displayName: "disc-xmark__CollecticonDiscXmark",
  componentId: "sc-1c7ctan-0"
})([""]);

var CollecticonDownload2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'download 2 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12.706,8.294l-1.416-1.416L9,9.172V0H7v9.172L4.706,6.878L3.291,8.294L8,13L12.706,8.294z M16,14H0v2h16V14z"
  }));
})).withConfig({
  displayName: "download-2__CollecticonDownload2",
  componentId: "sc-13uh0ce-0"
})([""]);

var CollecticonDownload = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'download icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12.706,8.294l-1.416-1.416L9,9.172V0H7v9.172L4.706,6.878L3.291,8.294L8,13L12.706,8.294z M14,4v10H2V4H0v12h16V4H14z"
  }));
})).withConfig({
  displayName: "download__CollecticonDownload",
  componentId: "sc-1wcnsuh-0"
})([""]);

var CollecticonDrop = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'drop icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,13c2,0,4.497-1.5,4-4C11,9,6,13,8,13z M8,0c0,0-7,5-7,10c0,4,3.688,6,7,6s7-2,7-6C15,5,8,0,8,0z M12.606,11.687 c-0.244,0.456-0.6,0.866-1.062,1.209c-0.466,0.35-1.019,0.622-1.641,0.816C9.294,13.9,8.637,14,8,14s-1.294-0.1-1.903-0.288 c-0.622-0.191-1.175-0.466-1.641-0.816c-0.463-0.347-0.819-0.753-1.062-1.209C3.131,11.194,3,10.625,3,10 c0-0.788,0.278-1.684,0.825-2.669c0.494-0.891,1.2-1.831,2.094-2.794C6.659,3.741,7.406,3.056,8,2.553 c0.594,0.503,1.341,1.184,2.084,1.984c0.894,0.966,1.6,1.906,2.094,2.794C12.722,8.316,13,9.212,13,10 C13,10.625,12.866,11.194,12.606,11.687z"
  }));
})).withConfig({
  displayName: "drop__CollecticonDrop",
  componentId: "sc-x9gde6-0"
})([""]);

var CollecticonEllipsisHorizontal = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'ellipsis horizontal icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,8c0-1.103-0.897-2-2-2S0,6.897,0,8s0.897,2,2,2S4,9.103,4,8z M6,8c0,1.103,0.897,2,2,2s2-0.897,2-2S9.103,6,8,6 S6,6.897,6,8z M12,8c0,1.103,0.897,2,2,2s2-0.897,2-2s-0.897-2-2-2S12,6.897,12,8z"
  }));
})).withConfig({
  displayName: "ellipsis-horizontal__CollecticonEllipsisHorizontal",
  componentId: "sc-1qnc74s-0"
})([""]);

var CollecticonEllipsisVertical = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'ellipsis vertical icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,4c1.103,0,2-0.897,2-2S9.103,0,8,0S6,0.897,6,2S6.897,4,8,4z M8,6C6.897,6,6,6.897,6,8s0.897,2,2,2s2-0.897,2-2 S9.103,6,8,6z M8,12c-1.103,0-2,0.897-2,2s0.897,2,2,2s2-0.897,2-2S9.103,12,8,12z"
  }));
})).withConfig({
  displayName: "ellipsis-vertical__CollecticonEllipsisVertical",
  componentId: "sc-179rm06-0"
})([""]);

var CollecticonEnvelope = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'envelope icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,6v8h16V6l-8,5L0,6z M0,2v2l8,5l8-5V2H0z"
  }));
})).withConfig({
  displayName: "envelope__CollecticonEnvelope",
  componentId: "sc-yidx52-0"
})([""]);

var CollecticonEqualSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'equal small icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2,11h12V9H2V11z M2,5v2h12V5H2z"
  }));
})).withConfig({
  displayName: "equal--small__CollecticonEqualSmall",
  componentId: "sc-wsga5u-0"
})([""]);

var CollecticonEqual = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'equal icon'), /*#__PURE__*/React.createElement("path", {
    d: "M1,11h14V9H1V11z M1,5v2h14V5H1z"
  }));
})).withConfig({
  displayName: "equal__CollecticonEqual",
  componentId: "sc-1fa0j72-0"
})([""]);

var CollecticonExclamationSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'exclamation small icon'), /*#__PURE__*/React.createElement("path", {
    d: "M9,11C9,10.447 8.553,10 8,10C7.447,10 7,10.447 7,11C7,11.553 7.447,12 8,12C8.553,12 9,11.553 9,11ZM9,4L9,9L7,9L7,4L9,4Z"
  }));
})).withConfig({
  displayName: "exclamation--small__CollecticonExclamationSmall",
  componentId: "sc-8rmq3h-0"
})([""]);

var CollecticonExpandCollapse = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'expand collapse icon'), /*#__PURE__*/React.createElement("path", {
    id: "expand-collapse",
    d: "M4.414,15.414L8,11.828L11.586,15.414L13,14L8,9L3,14L4.414,15.414ZM11.586,0.586L8,4.172L4.414,0.586L3,2L8,7L13,2L11.586,0.586Z"
  }));
})).withConfig({
  displayName: "expand-collapse__CollecticonExpandCollapse",
  componentId: "sc-12n4ycf-0"
})([""]);

var CollecticonExpandDownLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'expand down left icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13,11H9v2h6V1H3v6h2V3h8V11z M0,8v8h8v-2H3.412l6.294-6.294L8.294,6.294L2,12.587V8H0z"
  }));
})).withConfig({
  displayName: "expand-down-left__CollecticonExpandDownLeft",
  componentId: "sc-1rjpycs-0"
})([""]);

var CollecticonExpandDownRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'expand down right icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3,3h8v4h2V1H1v12h6v-2H3V3z M14,8v4.587L7.706,6.294L6.294,7.706L12.587,14H8v2h8V8H14z"
  }));
})).withConfig({
  displayName: "expand-down-right__CollecticonExpandDownRight",
  componentId: "sc-10e6gt6-0"
})([""]);

var CollecticonExpandFromLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'expand from left icon'), /*#__PURE__*/React.createElement("path", {
    id: "expand-from-left",
    d: "M16,16L0,16L0,0L16,0L16,16ZM4,2L4,14L14,14L14,2L4,2ZM5.586,5.414L8.172,8L5.586,10.586L7,12L11,8L7,4L5.586,5.414Z"
  }));
})).withConfig({
  displayName: "expand-from-left__CollecticonExpandFromLeft",
  componentId: "sc-xntp9m-0"
})([""]);

var CollecticonExpandFromRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'expand from right icon'), /*#__PURE__*/React.createElement("path", {
    id: "expand-from-right",
    d: "M0,0L16,0L16,16L0,16L0,0ZM12,14L12,2L2,2L2,14L12,14ZM10.414,10.586L7.828,8L10.414,5.414L9,4L5,8L9,12L10.414,10.586Z"
  }));
})).withConfig({
  displayName: "expand-from-right__CollecticonExpandFromRight",
  componentId: "sc-8rny95-0"
})([""]);

var CollecticonExpandTopLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'expand top left icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13,13H5V9H3v6h12V3H9v2h4V13z M2,8V3.413l6.294,6.294l1.413-1.413L3.412,2H8V0L0,0l0,8H2z"
  }));
})).withConfig({
  displayName: "expand-top-left__CollecticonExpandTopLeft",
  componentId: "sc-1bzl97p-0"
})([""]);

var CollecticonExpandTopRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'expand top right icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3,5h4V3H1v12h12V9h-2v4H3V5z M16,8V0L8,0v2h4.587L6.294,8.294l1.413,1.413L14,3.413V8H16z"
  }));
})).withConfig({
  displayName: "expand-top-right__CollecticonExpandTopRight",
  componentId: "sc-1bjhv94-0"
})([""]);

var CollecticonEyeDisabled = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'eye disabled icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11.685,2.886L11.686,2.886L14.586,-0.014L16,1.4L13.345,4.055C15.264,5.792 16,8 16,8C16,8 14,14 8,14C6.537,14 5.312,13.643 4.296,13.104L1.4,16L-0.014,14.586L2.64,11.932L2.64,11.932L4.055,10.516L4.055,10.516L5.472,9.1L5.472,9.1L11.685,2.886ZM5.806,11.594C6.444,11.846 7.173,12 8,12C11.479,12 13.214,9.267 13.832,8C13.519,7.356 12.917,6.338 11.949,5.49C11.97,5.658 12,5.825 12,6C12,8.209 10.209,10 8,10C7.81,10 7.622,9.987 7.439,9.961L5.806,11.594ZM1.669,10.902C0.478,9.435 0,8 0,8C0,8 2,2 8,2C8.828,2 9.579,2.114 10.26,2.311L4.549,8.023C4.2,7.429 4,6.738 4,6C4,5.826 4.03,5.66 4.051,5.491C3.082,6.34 2.481,7.358 2.168,8C2.361,8.396 2.661,8.932 3.088,9.484L1.669,10.902Z"
  }));
})).withConfig({
  displayName: "eye-disabled__CollecticonEyeDisabled",
  componentId: "sc-4xvufx-0"
})([""]);

var CollecticonEye = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'eye icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,2C2,2 0,8 0,8C0,8 2,14 8,14C14,14 16,8 16,8C16,8 14,2 8,2ZM8,12C4.519,12 2.787,9.272 2.168,8C2.481,7.358 3.082,6.34 4.051,5.491C4.03,5.66 4,5.826 4,6C4,8.209 5.791,10 8,10C10.209,10 12,8.209 12,6C12,5.825 11.97,5.658 11.949,5.49C12.917,6.338 13.519,7.356 13.832,8C13.214,9.267 11.479,12 8,12Z"
  }));
})).withConfig({
  displayName: "eye__CollecticonEye",
  componentId: "sc-1wfb5gr-0"
})([""]);

var CollecticonFaceHappy = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'face happy icon'), /*#__PURE__*/React.createElement("path", {
    d: "M5,7C5.553,7 6,6.553 6,6C6,5.447 5.553,5 5,5C4.447,5 4,5.447 4,6C4,6.553 4.447,7 5,7ZM8,10C7.263,10 6.616,9.597 6.269,9L4.125,9C4.569,10.725 6.134,12 8,12C9.863,12 11.431,10.725 11.875,9L9.731,9C9.384,9.597 8.738,10 8,10ZM8,0C3.581,0 0,3.581 0,8C0,12.419 3.581,16 8,16C12.419,16 16,12.419 16,8C16,3.581 12.419,0 8,0ZM12.244,12.244C11.109,13.375 9.603,14 8,14C6.397,14 4.891,13.375 3.756,12.244C2.625,11.109 2,9.603 2,8C2,6.397 2.625,4.891 3.756,3.756C4.891,2.625 6.397,2 8,2C9.603,2 11.109,2.625 12.244,3.756C13.375,4.891 14,6.397 14,8C14,9.603 13.375,11.109 12.244,12.244ZM11,5C10.447,5 10,5.447 10,6C10,6.553 10.447,7 11,7C11.553,7 12,6.553 12,6C12,5.447 11.553,5 11,5Z"
  }));
})).withConfig({
  displayName: "face-happy__CollecticonFaceHappy",
  componentId: "sc-1h06tny-0"
})([""]);

var CollecticonFaceSad = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'face sad icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,8C6.134,8 4.569,9.275 4.125,11L6.269,11C6.616,10.403 7.263,10 8,10C8.738,10 9.384,10.403 9.731,11L11.875,11C11.431,9.275 9.863,8 8,8ZM5,7C5.553,7 6,6.553 6,6C6,5.447 5.553,5 5,5C4.447,5 4,5.447 4,6C4,6.553 4.447,7 5,7ZM8,0C3.581,0 0,3.581 0,8C0,12.419 3.581,16 8,16C12.419,16 16,12.419 16,8C16,3.581 12.419,0 8,0ZM12.244,12.244C11.109,13.375 9.603,14 8,14C6.397,14 4.891,13.375 3.756,12.244C2.625,11.109 2,9.603 2,8C2,6.397 2.625,4.891 3.756,3.756C4.891,2.625 6.397,2 8,2C9.603,2 11.109,2.625 12.244,3.756C13.375,4.891 14,6.397 14,8C14,9.603 13.375,11.109 12.244,12.244ZM11,5C10.447,5 10,5.447 10,6C10,6.553 10.447,7 11,7C11.553,7 12,6.553 12,6C12,5.447 11.553,5 11,5Z"
  }));
})).withConfig({
  displayName: "face-sad__CollecticonFaceSad",
  componentId: "sc-wspec2-0"
})([""]);

var CollecticonFactory = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'factory icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,16h3V0H0V16z M10,8V4L4,8v8h6v-4h2v4h4V4L10,8z"
  }));
})).withConfig({
  displayName: "factory__CollecticonFactory",
  componentId: "sc-1to3481-0"
})([""]);

var CollecticonFence = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'fence icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,0l-2,2v2h-2V2L8,0L6,2v2H4V2L2,0L0,2v14h4v-2h2v2h4v-2h2v2h4V2L14,0z M4,12V6h2v6H4z M10,12V6h2v6H10z"
  }));
})).withConfig({
  displayName: "fence__CollecticonFence",
  componentId: "sc-ndm71b-0"
})([""]);

var CollecticonFilter = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'filter icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7,16L7,10L0,2L0,0L16,0L16,2L9,10L9,14L7,16Z"
  }));
})).withConfig({
  displayName: "filter__CollecticonFilter",
  componentId: "sc-eblqxv-0"
})([""]);

var CollecticonFlagPole = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'flag pole icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2.009,0H1.991C1.444,0,1,0.444,1,0.991V16h2V0.991C3,0.444,2.556,0,2.009,0z M16,1H4v8h12l-4-4L16,1z"
  }));
})).withConfig({
  displayName: "flag-pole__CollecticonFlagPole",
  componentId: "sc-13b70b-0"
})([""]);

var CollecticonFlame = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'flame icon'), /*#__PURE__*/React.createElement("path", {
    d: "M9.65,4.05C9.8,4.2,9.95,4.35,10.1,4.5c0.9,0.95,1.6,1.9,2.1,2.8c0.55,1,0.85,1.9,0.85,2.65c0,0.6-0.15,1.2-0.4,1.7 c-0.25,0.45-0.6,0.85-1.05,1.2c-0.45,0.35-1,0.6-1.65,0.8C9.3,13.9,8.65,14,8,14s-1.3-0.1-1.9-0.3s-1.15-0.45-1.65-0.8 C4,12.55,3.65,12.15,3.4,11.7C3.15,11.2,3,10.65,3,10c0-0.6,0.2-1.3,0.65-2.1C3.75,7.7,3.85,7.5,4,7.3c0.8,0.65,1.55,0.8,2.05,0.8 C6.9,8.1,7.7,7.7,8.35,7c0.4-0.5,0.75-1.1,1-1.85C9.45,4.8,9.55,4.45,9.65,4.05 M8,0c0,3.9-0.85,6.1-1.95,6.1C5.45,6.1,4.7,5.45,4,4 c-1.65,1.85-3,4-3,6c0,4,3.7,6,7,6l0,0c3.3,0,7-2,7-6C15,5,8,0,8,0L8,0z"
  }));
})).withConfig({
  displayName: "flame__CollecticonFlame",
  componentId: "sc-fx7lds-0"
})([""]);

var CollecticonFolder = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'folder icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7,1l2,2h7v11H0V1H7z"
  }));
})).withConfig({
  displayName: "folder__CollecticonFolder",
  componentId: "sc-1s4zkne-0"
})([""]);

var CollecticonGauge = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'gauge icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M8,14c-3.312,0-6-2.688-6-6s2.688-6,6-6s6,2.688,6,6 S11.312,14,8,14z M8.225,8.016L6.172,5.387l0.575,3.287C6.591,8.912,6.5,9.194,6.5,9.5C6.5,10.328,7.172,11,8,11s1.5-0.672,1.5-1.5 C9.5,8.75,8.947,8.125,8.225,8.016z M8,3C5.581,3,3.562,4.719,3.1,7h1.141C4.412,6.344,4.756,5.744,5.25,5.25 C5.984,4.516,6.963,4.113,8,4.113s2.016,0.403,2.75,1.137c0.494,0.494,0.837,1.094,1.009,1.75H12.9C12.438,4.719,10.419,3,8,3z"
  }));
})).withConfig({
  displayName: "gauge__CollecticonGauge",
  componentId: "sc-5yj9ve-0"
})([""]);

var CollecticonGitFork = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'git fork icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13,9v2h-2.488c-0.047-0.006-0.131-0.044-0.169-0.069L7.416,8l2.931-2.931C10.384,5.041,10.469,5.006,10.516,5H13v2l3-3 l-3-3v2h-2.5C9.962,3,9.319,3.266,8.941,3.647L6.584,6H0v4h6.584l2.353,2.353C9.319,12.734,9.959,13,10.497,13h2.5v2l3-3L13,9z"
  }));
})).withConfig({
  displayName: "git-fork__CollecticonGitFork",
  componentId: "sc-kkuh2n-0"
})([""]);

var CollecticonGlobe = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'globe icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M3.756,12.244C2.625,11.109,2,9.603,2,8 c0-0.569,0.078-1.122,0.231-1.653l0.506,1.334l2.819,2.225l0.469,0.106l-0.691,1.106l1.022,2.653 C5.384,13.497,4.494,12.978,3.756,12.244z M12.822,11.575c-0.175,0.234-0.369,0.459-0.578,0.669 c-1.084,1.084-2.512,1.703-4.041,1.753l1.678-1.325l0.216-1.131L5.856,9.569L5.594,9.112L5.25,8.875L5.072,8.091L4.491,8.328 l0.194-0.762l0.694-0.091l0.619,0.688L6.2,6.975l0.759-1.05l0.809-0.287L7.85,5.091L7.675,4.903l0.766-0.125l0.087-0.6L7.834,3.462 L7.241,3.541L6.506,3.175l-0.4,1.253L5.222,3.891l1.284-1.344L4.862,2.881c0.831-0.509,1.772-0.809,2.759-0.869L9.484,3.65 l0.684,0.184l0.144-0.528l0.703-0.491c0.441,0.256,0.85,0.572,1.219,0.941c0.184,0.184,0.356,0.381,0.516,0.584l-0.544,0.941 l-0.534,0.106l0.656,4.137l0.731,0.766L12.822,11.575z M12.859,6.191l0.247-0.331L13.387,6.2L12.859,6.191z"
  }));
})).withConfig({
  displayName: "globe__CollecticonGlobe",
  componentId: "sc-10oai70-0"
})([""]);

var CollecticonGripHorizontal = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'grip horizontal icon'), /*#__PURE__*/React.createElement("path", {
    id: "grip-horizontal",
    d: "M3,7l-0,-2l-2,0l-0,2l2,0Zm-0,4l-0,-2l-2,0l-0,2l2,0Zm4,-4l-0,-2l-2,0l-0,2l2,0Zm-0,4l-0,-2l-2,0l-0,2l2,0Zm4,-4l-0,-2l-2,0l-0,2l2,0Zm0,4l0,-2l-2,0l0,2l2,0Zm4,-4l-0,-2l-2,0l-0,2l2,0Zm-0,4l-0,-2l-2,0l0,2l2,0Z"
  }));
})).withConfig({
  displayName: "grip-horizontal__CollecticonGripHorizontal",
  componentId: "sc-16u2dmc-0"
})([""]);

var CollecticonGripVertical = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'grip vertical icon'), /*#__PURE__*/React.createElement("path", {
    id: "grip-vertical",
    d: "M7,13L5,13L5,15L7,15L7,13ZM11,13L9,13L9,15L11,15L11,13ZM7,9L5,9L5,11L7,11L7,9ZM11,9L9,9L9,11L11,11L11,9ZM7,5L5,5L5,7L7,7L7,5ZM11,5L9,5L9,7L11,7L11,5ZM7,1L5,1L5,3L7,3L7,1ZM11,1L9,1L9,3L11,3L11,1Z"
  }));
})).withConfig({
  displayName: "grip-vertical__CollecticonGripVertical",
  componentId: "sc-maqm4u-0"
})([""]);

var CollecticonHamburgerMenu = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'hamburger menu icon'), /*#__PURE__*/React.createElement("path", {
    d: "M1,9h14V7H1V9z M1,14h14v-2H1V14z M1,2v2h14V2H1z"
  }));
})).withConfig({
  displayName: "hamburger-menu__CollecticonHamburgerMenu",
  componentId: "sc-179stu8-0"
})([""]);

var CollecticonHandPan = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'hand pan icon'), /*#__PURE__*/React.createElement("path", {
    id: "hand-pan",
    d: "M8,8L8,1C8,0.448 8.448,0 9,0C9.552,0 10,0.448 10,1L10,8L11,8L11,2C11,1.448 11.448,1 12,1C12.552,1 13,1.448 13,2L13,8L14,8L14,5C14,4.448 14.448,4 15,4C15.552,4 16,4.448 16,5L16,9L16,9.001L16,14C16,14.53 15.789,15.039 15.414,15.414C15.039,15.789 14.53,16 14,16C11.883,16 8.628,16 7,16C6.37,16 5.778,15.704 5.4,15.2C3.88,13.174 0,8 0,8C0,8 0,8 0,8C0.574,7.426 1.482,7.362 2.131,7.848L5,10L5,3C5,2.448 5.448,2 6,2C6.552,2 7,2.448 7,3L7,8L8,8Z"
  }));
})).withConfig({
  displayName: "hand-pan__CollecticonHandPan",
  componentId: "sc-1o21t5t-0"
})([""]);

var CollecticonHandSwipeHorizontal = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'hand swipe horizontal icon'), /*#__PURE__*/React.createElement("path", {
    id: "hand-swipe-horizontal",
    d: "M5,11L5,4.5C5,3.672 5.672,3 6.5,3C7.328,3 8,3.672 8,4.5L8,8L9.528,8C9.838,8 10.145,8.072 10.422,8.211C11.005,8.502 12.076,9.038 12.894,9.447C13.572,9.786 14,10.479 14,11.236C14,12.022 14,13.063 14,14C14,14.53 13.789,15.039 13.414,15.414C13.039,15.789 12.53,16 12,16L6.702,16C6.247,16 5.807,15.845 5.452,15.562C4.154,14.523 1,12 1,12C1,11.448 1.448,11 2,11L5,11ZM2,4.5C2,2.016 4.016,-0 6.5,-0C8.984,-0 11,2.016 11,4.5C11,4.5 9,4.5 9,4.5C9,3.12 7.88,2 6.5,2C5.12,2 4,3.12 4,4.5C4,4.5 2,4.5 2,4.5Z"
  }));
})).withConfig({
  displayName: "hand-swipe-horizontal__CollecticonHandSwipeHorizontal",
  componentId: "sc-15beqjt-0"
})([""]);

var CollecticonHandThumbsDown = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'hand thumbs down icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3,10L3,1L0,1L0,10L3,10ZM15,11C15.265,11 15.52,10.895 15.707,10.707C15.895,10.52 16,10.265 16,10C16,8.833 16,6.975 16,6.277C16,6.096 15.951,5.918 15.857,5.762C15.455,5.092 14.295,3.158 13.583,1.971C13.221,1.369 12.57,1 11.868,1C10.397,1 7.805,1 6,1C5.47,1 4.961,1.211 4.586,1.586C4.211,1.961 4,2.47 4,3C4,5.255 4,8.803 4,10.298C4,10.753 4.155,11.193 4.438,11.548C5.477,12.846 8,16 8,16C8,16 8,16 8,16C8.552,16 9,15.552 9,15L9,11L15,11Z"
  }));
})).withConfig({
  displayName: "hand-thumbs-down__CollecticonHandThumbsDown",
  componentId: "sc-1kyach0-0"
})([""]);

var CollecticonHandThumbsUp = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'hand thumbs up icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3,6L3,15L0,15L0,6L3,6ZM15,5C15.265,5 15.52,5.105 15.707,5.293C15.895,5.48 16,5.735 16,6C16,7.167 16,9.025 16,9.723C16,9.904 15.951,10.082 15.857,10.238C15.455,10.908 14.295,12.842 13.583,14.029C13.221,14.631 12.57,15 11.868,15C10.397,15 7.805,15 6,15C5.47,15 4.961,14.789 4.586,14.414C4.211,14.039 4,13.53 4,13C4,10.745 4,7.197 4,5.702C4,5.247 4.155,4.807 4.438,4.452C5.477,3.154 8,0 8,0C8,0 8,0 8,0C8.552,0 9,0.448 9,1L9,5L15,5Z"
  }));
})).withConfig({
  displayName: "hand-thumbs-up__CollecticonHandThumbsUp",
  componentId: "sc-ywkjmo-0"
})([""]);

var CollecticonHeading = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'heading icon'), /*#__PURE__*/React.createElement("path", {
    id: "heading",
    d: "M11,8l-6,0l0,-7l-2,0l0,14l2,0l0,-5l6,0l0,5l2,0l0,-14l-2,0l0,7Z"
  }));
})).withConfig({
  displayName: "heading__CollecticonHeading",
  componentId: "sc-1rw8j61-0"
})([""]);

var CollecticonHeart = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'heart icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11.75,1C10.126,1,8.716,1.911,8,3.249C7.284,1.911,5.874,1,4.25,1C1.903,1,0,2.903,0,5.25C0,11,8,15,8,15s8-4,8-9.75 C16,2.903,14.097,1,11.75,1z"
  }));
})).withConfig({
  displayName: "heart__CollecticonHeart",
  componentId: "sc-18uyj45-0"
})([""]);

var CollecticonHouse = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'house icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "0,6 0,16 6,16 6,10 10,10 10,16 16,16 16,6 8,0"
  }));
})).withConfig({
  displayName: "house__CollecticonHouse",
  componentId: "sc-1fgnmhh-0"
})([""]);

var CollecticonHouses = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'houses icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,8v7h3v-4h3v4h6V8L6,3L0,8z M10,1L7.6,3L13,7.5V13h3V6L10,1z"
  }));
})).withConfig({
  displayName: "houses__CollecticonHouses",
  componentId: "sc-39h0d0-0"
})([""]);

var CollecticonIsoStack = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'iso stack icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,9L0,5l8-4l8,4L8,9z M14.397,7.2L16,8l-8,4L0,8l1.603-0.8L8,10.397L14.397,7.2z M14.397,10.2L16,11l-8,4l-8-4l1.603-0.8 L8,13.397L14.397,10.2z"
  }));
})).withConfig({
  displayName: "iso-stack__CollecticonIsoStack",
  componentId: "sc-187l9aa-0"
})([""]);

var CollecticonItalic = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'italic icon'), /*#__PURE__*/React.createElement("path", {
    id: "italic",
    d: "M9.439,3l-5,10l-3.439,0l-0,2l9,0l0,-2l-3.439,0l5,-10l3.439,0l0,-2l-9,0l0,2l3.439,0Z"
  }));
})).withConfig({
  displayName: "italic__CollecticonItalic",
  componentId: "sc-ra4udc-0"
})([""]);

var CollecticonKeyboard = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'keyboard icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,4c-0,-1.105 -0.895,-2 -2,-2c-3.074,0 -8.926,0 -12,0c-1.105,0 -2,0.895 -2,2c0,2.22 0,5.78 0,8c0,1.105 0.895,2 2,2c3.074,0 8.926,0 12,0c1.105,-0 2,-0.895 2,-2c0,-2.22 0,-5.78 0,-8Zm-4,6l0,2l-8,0l0,-2l8,0Zm-8,-3l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm4,0l0,2l-3,0l0,-2l3,0Zm-10,-3l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm4,0l0,2l-3,0l0,-2l3,0Z"
  }));
})).withConfig({
  displayName: "keyboard__CollecticonKeyboard",
  componentId: "sc-kehk32-0"
})([""]);

var CollecticonLayoutColumn2x = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'layout column 2x icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,16L7,16L7,0L0,0L0,16ZM15,16L15,0L8,0L8,16L15,16Z"
  }));
})).withConfig({
  displayName: "layout-column-2x__CollecticonLayoutColumn2x",
  componentId: "sc-11ojdwa-0"
})([""]);

var CollecticonLayoutGrid2x2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'layout grid 2x2 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7,9L7,16L0,16L0,9L7,9ZM15,9L15,16L8,16L8,9L15,9ZM7,1L7,8L0,8L0,1L7,1ZM15,1L15,8L8,8L8,1L15,1Z"
  }));
})).withConfig({
  displayName: "layout-grid-2x2__CollecticonLayoutGrid2x2",
  componentId: "sc-14yggc1-0"
})([""]);

var CollecticonLayoutGrid3x3 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'layout grid 3x3 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M1,1h4v4H1V1z M6,1h4v4H6V1z M11,1h4v4h-4V1z M1,6h4v4H1V6z M6,6h4v4H6V6z M11,6h4v4h-4V6z M1,11h4v4H1V11z M6,11h4v4H6V11z M11,11h4v4h-4V11z"
  }));
})).withConfig({
  displayName: "layout-grid-3x3__CollecticonLayoutGrid3x3",
  componentId: "sc-1j22hjj-0"
})([""]);

var CollecticonLayoutRow2x = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'layout row 2x icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0,7L16,7L16,0L0,0ZM0,15L16,15L16,8L0,8L0,15Z"
  }));
})).withConfig({
  displayName: "layout-row-2x__CollecticonLayoutRow2x",
  componentId: "sc-uoth1p-0"
})([""]);

var CollecticonLeaf = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'leaf icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C4.134,0,1,3.134,1,7v9h2v-4c0-3.866,3.134-7,7-7h2c-3.866,0-7,3.134-7,7v2h3c3.866,0,7-3.134,7-7V0H8z"
  }));
})).withConfig({
  displayName: "leaf__CollecticonLeaf",
  componentId: "sc-1mdo8m2-0"
})([""]);

var CollecticonLink = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'link icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6.794,12.794C6.316,13.269,5.681,13.531,5,13.531s-1.316-0.262-1.794-0.738c-0.987-0.988-0.987-2.597,0-3.584L5.5,6.916 L4.084,5.5L1.791,7.794c-1.766,1.769-1.766,4.644,0.003,6.413C2.647,15.062,3.784,15.531,5,15.531s2.353-0.469,3.206-1.325 l2.294-2.294L9.084,10.5L6.794,12.794z M14.206,1.794C13.353,0.938,12.216,0.469,11,0.469S8.647,0.938,7.794,1.794L5.5,4.084 L6.916,5.5l2.294-2.294C9.684,2.731,10.319,2.469,11,2.469s1.316,0.263,1.794,0.737c0.988,0.987,0.988,2.597,0,3.584L10.5,9.084 l1.416,1.416l2.294-2.294C15.975,6.438,15.975,3.562,14.206,1.794z M11.706,5.706l-1.416-1.416l-6,6l1.416,1.416L11.706,5.706z"
  }));
})).withConfig({
  displayName: "link__CollecticonLink",
  componentId: "sc-w4hhqn-0"
})([""]);

var CollecticonListNumbered = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'list numbered icon'), /*#__PURE__*/React.createElement("path", {
    id: "list-numbered",
    d: "M0,10l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Zm4,1l12,0l0,2l-12,0l0,-2Zm0,-4l12,0l0,2l-12,0l0,-2Zm-3,-3.75c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-0.75,0l0,-1l1,0c0.552,0 1,0.448 1,1c-0,1.185 0,4 0,4l-1,0l0,-3.75Zm3,-0.25l12,0l0,2l-12,0l0,-2Z"
  }));
})).withConfig({
  displayName: "list-numbered__CollecticonListNumbered",
  componentId: "sc-1y4r290-0"
})([""]);

var CollecticonList = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'list icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,3v2h12V3H4z M0,5h2V3H0V5z M4,9h12V7H4V9z M0,9h2V7H0V9z M4,13h12v-2H4V13z M0,13h2v-2H0V13z"
  }));
})).withConfig({
  displayName: "list__CollecticonList",
  componentId: "sc-33nw9x-0"
})([""]);

var CollecticonLock2Open = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'lock 2 open icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12.25,7H12V4c0-1.653-1.347-3-3-3H7C5.347,1,4,2.347,4,4v1h2V4c0-0.55,0.45-1,1-1h2c0.55,0,1,0.45,1,1v3H3.75 C3.338,7,3,7.338,3,7.75v6.5C3,14.662,3.338,15,3.75,15h8.5c0.412,0,0.75-0.338,0.75-0.75v-6.5C13,7.338,12.662,7,12.25,7z"
  }));
})).withConfig({
  displayName: "lock-2-open__CollecticonLock2Open",
  componentId: "sc-zzwhkx-0"
})([""]);

var CollecticonLock2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'lock 2 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12.25,7H12V4c0-1.653-1.347-3-3-3H7C5.347,1,4,2.347,4,4v3H3.75C3.338,7,3,7.338,3,7.75v6.5C3,14.663,3.338,15,3.75,15h8.5 c0.413,0,0.75-0.337,0.75-0.75v-6.5C13,7.338,12.663,7,12.25,7z M6,4c0-0.55,0.45-1,1-1h2c0.55,0,1,0.45,1,1v3H6V4z"
  }));
})).withConfig({
  displayName: "lock-2__CollecticonLock2",
  componentId: "sc-1pa8bjy-0"
})([""]);

var CollecticonLockOpen = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'lock open icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,7h-1V4c0-2.206-1.794-4-4-4H7C4.794,0,3,1.794,3,4h2c0-1.103,0.897-2,2-2h2c1.103,0,2,0.897,2,2v3H8H2 C1.45,7,1,7.45,1,8v7c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1V8C15,7.45,14.55,7,14,7z M9,12.731V13.5c0,0.55-0.45,1-1,1 s-1-0.45-1-1v-0.769C6.403,12.384,6,11.741,6,11c0-1.103,0.897-2,2-2s2,0.897,2,2C10,11.741,9.597,12.384,9,12.731z"
  }));
})).withConfig({
  displayName: "lock-open__CollecticonLockOpen",
  componentId: "sc-xf9pgz-0"
})([""]);

var CollecticonLock = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'lock icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,7h-1V4c0-2.206-1.794-4-4-4H7C4.794,0,3,1.794,3,4v3H2C1.45,7,1,7.45,1,8v7c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1V8 C15,7.45,14.55,7,14,7z M9,12.731V13.5c0,0.55-0.45,1-1,1s-1-0.45-1-1v-0.769C6.403,12.384,6,11.741,6,11c0-1.103,0.897-2,2-2 s2,0.897,2,2C10,11.741,9.597,12.384,9,12.731z M5,7V4c0-1.103,0.897-2,2-2h2c1.103,0,2,0.897,2,2v3H5z"
  }));
})).withConfig({
  displayName: "lock__CollecticonLock",
  componentId: "sc-o95j22-0"
})([""]);

var CollecticonLogin = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'login icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,14l0,-12l-6,0l0,-2l8,0l0,16l-8,0l0,-2l6,0Zm-6.998,-0.998l4.998,-5.002l-5,-5l-1.416,1.416l2.588,2.584l-8.172,0l0,2l8.172,0l-2.586,2.586l1.416,1.416Z"
  }));
})).withConfig({
  displayName: "login__CollecticonLogin",
  componentId: "sc-1y1wjb9-0"
})([""]);

var CollecticonLogout = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'logout icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,14l0,-12l-6,0l0,-2l8,0l0,16l-8,0l0,-2l6,0Zm-9.002,-0.998l-4.998,-5.002l5,-5l1.416,1.416l-2.588,2.584l8.172,0l0,2l-8.172,0l2.586,2.586l-1.416,1.416Z"
  }));
})).withConfig({
  displayName: "logout__CollecticonLogout",
  componentId: "sc-1iqecrb-0"
})([""]);

var CollecticonMagnifierLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'magnifier left icon'), /*#__PURE__*/React.createElement("path", {
    d: "M15.708,13.587l-3.675-3.675C12.646,8.92,13,7.751,13,6.5C13,2.91,10.09,0,6.5,0S0,2.91,0,6.5S2.91,13,6.5,13 c1.251,0,2.42-0.354,3.412-0.967l3.675,3.675c0.389,0.389,1.025,0.389,1.414,0l0.707-0.707 C16.097,14.612,16.097,13.976,15.708,13.587z M3.318,9.682C2.468,8.832,2,7.702,2,6.5s0.468-2.332,1.318-3.182S5.298,2,6.5,2 s2.332,0.468,3.182,1.318C10.532,4.168,11,5.298,11,6.5s-0.468,2.332-1.318,3.182C8.832,10.532,7.702,11,6.5,11 S4.168,10.532,3.318,9.682z"
  }));
})).withConfig({
  displayName: "magnifier-left__CollecticonMagnifierLeft",
  componentId: "sc-16fyszn-0"
})([""]);

var CollecticonMagnifierRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'magnifier right icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0.292,15.001l0.707,0.707c0.389,0.389,1.025,0.389,1.414,0l3.675-3.675C7.08,12.646,8.249,13,9.5,13 c3.59,0,6.5-2.91,6.5-6.5S13.09,0,9.5,0S3,2.91,3,6.5c0,1.251,0.354,2.42,0.967,3.412l-3.675,3.675 C-0.097,13.976-0.097,14.612,0.292,15.001z M9.5,11c-1.202,0-2.332-0.468-3.182-1.318C5.468,8.832,5,7.702,5,6.5 s0.468-2.332,1.318-3.182S8.298,2,9.5,2s2.332,0.468,3.182,1.318C13.532,4.168,14,5.298,14,6.5s-0.468,2.332-1.318,3.182 C11.832,10.532,10.702,11,9.5,11z"
  }));
})).withConfig({
  displayName: "magnifier-right__CollecticonMagnifierRight",
  componentId: "sc-mpkmvd-0"
})([""]);

var CollecticonMap = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'map icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,3l5-2v12l-5,2V3z M11,3v12l-5-1.667v-12L11,3z M16,1v12l-4,1.6v-12L16,1z"
  }));
})).withConfig({
  displayName: "map__CollecticonMap",
  componentId: "sc-zq8trt-0"
})([""]);

var CollecticonMarker = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'marker icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
  }));
})).withConfig({
  displayName: "marker__CollecticonMarker",
  componentId: "sc-9444h2-0"
})([""]);

var CollecticonMinusSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'minus small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "14,7 2,7 2,9 14,9"
  }));
})).withConfig({
  displayName: "minus--small__CollecticonMinusSmall",
  componentId: "sc-idjajx-0"
})([""]);

var CollecticonMinus = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'minus icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "15,7 1,7 1,9 15,9"
  }));
})).withConfig({
  displayName: "minus__CollecticonMinus",
  componentId: "sc-1dxv3e5-0"
})([""]);

var CollecticonMobilePhone = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'mobile phone icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0h-7C3.675,0,3,0.675,3,1.5v13C3,15.325,3.675,16,4.5,16h7c0.825,0,1.5-0.675,1.5-1.5v-13C13,0.675,12.325,0,11.5,0z M8,15c-0.553,0-1-0.447-1-1s0.447-1,1-1s1,0.447,1,1S8.553,15,8,15z M12,12H4V2h8V12z"
  }));
})).withConfig({
  displayName: "mobile-phone__CollecticonMobilePhone",
  componentId: "sc-lfadc0-0"
})([""]);

var CollecticonOptionsTick = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'options tick icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,5l-11.012,0l0,9l11.012,0l0,1.988l-13,0l0,-12.976l13,0l0,1.988Zm-16,-4.988l14,0l0,1.988l-12.012,0l0,12l-1.988,0l0,-12l0,-1.988Zm8.2,8.36l-1.406,1.422l3.243,3.206l5.169,-5.747l-1.484,-1.338l-3.769,4.187l-1.753,-1.73Z"
  }));
})).withConfig({
  displayName: "options-tick__CollecticonOptionsTick",
  componentId: "sc-1rof8rz-0"
})([""]);

var CollecticonPageCog = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'page cog icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.706,4.206l-3.912-3.912C10.606,0.106,10.353,0,10.088,0H1v7h2V2h7v3h3v9H9v2h6V4.916C15,4.65,14.894,4.394,14.706,4.206 z M7.592,12.385L9,12.15v-1.288l-1.408-0.231c-0.069-0.25-0.166-0.482-0.288-0.697L8.137,8.77l-0.91-0.91L6.066,8.692 C5.847,8.573,5.618,8.473,5.377,8.407L5.146,7H3.857L3.626,8.407C3.382,8.473,3.15,8.573,2.934,8.692L1.771,7.86L0.86,8.77 l0.832,1.163c-0.119,0.219-0.219,0.447-0.285,0.691L0,10.856v1.288l1.408,0.231c0.066,0.244,0.166,0.475,0.285,0.691L0.86,14.23 l0.91,0.91l1.164-0.832c0.219,0.119,0.447,0.219,0.691,0.285L3.857,16h1.289l0.231-1.407c0.244-0.066,0.476-0.166,0.688-0.285 l1.164,0.832l0.91-0.91l-0.829-1.154C7.426,12.857,7.527,12.629,7.592,12.385z M4.492,12.788c-0.71,0-1.289-0.579-1.289-1.288 s0.579-1.288,1.289-1.288c0.71,0,1.289,0.575,1.289,1.288S5.202,12.788,4.492,12.788z"
  }));
})).withConfig({
  displayName: "page-cog__CollecticonPageCog",
  componentId: "sc-ne538-0"
})([""]);

var CollecticonPageLabel = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'page label icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.706,4.206l-3.912-3.912C10.606,0.106,10.353,0,10.088,0H1v8H0v4h10V8H3V2h7v3h3v9H3v-1H1v3h14V4.916 C15,4.65,14.894,4.394,14.706,4.206z"
  }));
})).withConfig({
  displayName: "page-label__CollecticonPageLabel",
  componentId: "sc-ihkl7a-0"
})([""]);

var CollecticonPageLockOpen = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'page lock open icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.706,4.206l-3.913-3.913C10.606,0.106,10.353,0,10.087,0H1v9h2V2h7v3h3v9H9v2h6V4.916C15,4.65,14.894,4.394,14.706,4.206 z M9,10h2V9c0-1.653-1.347-3-3-3S5,7.347,5,9v1H0.991C0.447,10,0,10.447,0,10.991v4.019C0,15.553,0.447,16,0.991,16h6.019 C7.553,16,8,15.553,8,15.009v-4.019C8,10.447,7.553,10,7.009,10H7V9c0-0.55,0.45-1,1-1s1,0.45,1,1V10z M4,14c-0.553,0-1-0.447-1-1 s0.447-1,1-1s1,0.447,1,1S4.553,14,4,14z"
  }));
})).withConfig({
  displayName: "page-lock-open__CollecticonPageLockOpen",
  componentId: "sc-9vft70-0"
})([""]);

var CollecticonPageTick = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'page tick icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.706,4.206l-3.913-3.913C10.606,0.106,10.353,0,10.087,0H1v16h14V4.916C15,4.65,14.894,4.394,14.706,4.206z M13,14H3V2h7 v3h3V14z M5.2,8.372L3.794,9.794L7.037,13l5.169-5.747l-1.484-1.338l-3.769,4.187L5.2,8.372z"
  }));
})).withConfig({
  displayName: "page-tick__CollecticonPageTick",
  componentId: "sc-19po8ir-0"
})([""]);

var CollecticonPageUp = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'page up icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.706,4.206c0.188,0.188 0.294,0.444 0.294,0.71l0,11.084l-14,0l0,-16l9.087,0c0.266,0 0.519,0.106 0.706,0.293l3.913,3.913Zm-1.706,9.794l0,-9l-3,0l0,-3l-7,0l0,12l10,0Zm-7.586,-3.586l-1.414,-1.414l4,-4l4,4l-1.414,1.414l-1.586,-1.586l0,4.172l-2,0l0,-4.172l-1.586,1.586Z"
  }));
})).withConfig({
  displayName: "page-up__CollecticonPageUp",
  componentId: "sc-gbkx4m-0"
})([""]);

var CollecticonPage = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'page icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.706,4.206l-3.913-3.913C10.606,0.106,10.353,0,10.087,0H1v16h14V4.916C15,4.65,14.894,4.394,14.706,4.206z M13,14H3V2h7 v3h3V14z"
  }));
})).withConfig({
  displayName: "page__CollecticonPage",
  componentId: "sc-k2xb9e-0"
})([""]);

var CollecticonPages = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'pages icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3,3H1v13h11v-2H3V3z M12,0H4v13h11V3L12,0z M13,11H6V2h5v2h2V11z"
  }));
})).withConfig({
  displayName: "pages__CollecticonPages",
  componentId: "sc-1td2367-0"
})([""]);

var CollecticonPencil = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'pencil icon'), /*#__PURE__*/React.createElement("path", {
    d: "M1,11v4h4l7-7L8,4L1,11z M11,1L9,3l4,4l2-2L11,1z"
  }));
})).withConfig({
  displayName: "pencil__CollecticonPencil",
  componentId: "sc-1kh2dl6-0"
})([""]);

var CollecticonPi = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'pi icon'), /*#__PURE__*/React.createElement("path", {
    id: "pi",
    d: "M4,4L6,4L6,14L4,14L4,4ZM14,14L12,14C11.47,14 10.961,13.789 10.586,13.414C10.211,13.039 10,12.53 10,12C10,9.082 10,4 10,4L12,4C12,4 12,9.749 12,11.5C12,11.633 12.053,11.76 12.146,11.854C12.24,11.947 12.367,12 12.5,12C13.092,12 14,12 14,12L14,14ZM2,2L14,2L14,4L2,4L2,2Z"
  }));
})).withConfig({
  displayName: "pi__CollecticonPi",
  componentId: "sc-wten9m-0"
})([""]);

var CollecticonPicture = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'picture icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7C12.328,7,13,6.328,13,5.5S12.328,4,11.5,4S10,4.672,10,5.5S10.672,7,11.5,7z M13,8l-4,2L6,5l-3,6v1h10V8z M0,1v14 h16V1H0z M14,13H2V3h12V13z"
  }));
})).withConfig({
  displayName: "picture__CollecticonPicture",
  componentId: "sc-23cpjo-0"
})([""]);

var CollecticonPilcrow = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'pilcrow icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,14L6,14L6,10C3.792,10 2,8.208 2,6C2,3.823 3.742,2.051 6,2L14,2L14,4L12,4L12,14L10,14L10,4L8,4L8,14Z"
  }));
})).withConfig({
  displayName: "pilcrow__CollecticonPilcrow",
  componentId: "sc-1b83p3i-0"
})([""]);

var CollecticonPlusSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'plus small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "14,7 9,7 9,2 7,2 7,7 2,7 2,9 7,9 7,14 9,14 9,9 14,9"
  }));
})).withConfig({
  displayName: "plus--small__CollecticonPlusSmall",
  componentId: "sc-1fqmt3p-0"
})([""]);

var CollecticonPlus = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'plus icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "15,7 9,7 9,1 7,1 7,7 1,7 1,9 7,9 7,15 9,15 9,9 15,9"
  }));
})).withConfig({
  displayName: "plus__CollecticonPlus",
  componentId: "sc-1fkp87s-0"
})([""]);

var CollecticonPopDown = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'pop down icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2,14h10V5H2V14z M4,7h6v5H4V7z M5,2v2h8v7h2V2H5z"
  }));
})).withConfig({
  displayName: "pop-down__CollecticonPopDown",
  componentId: "sc-1unqzj7-0"
})([""]);

var CollecticonPopUp = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'pop up icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,2v9h10V2H4z M12,9H6V4h6V9z M3,5H1v9h10v-2H3V5z"
  }));
})).withConfig({
  displayName: "pop-up__CollecticonPopUp",
  componentId: "sc-1l36dux-0"
})([""]);

var CollecticonPrinter = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'printer icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13,1H3v2h10V1z M15,4H1C0.45,4,0,4.45,0,5v5c0,0.55,0.45,1,1,1h2v4h10v-4h2c0.55,0,1-0.45,1-1V5C16,4.45,15.55,4,15,4z M11,13H5V9h6V13z M14,7c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S14.552,7,14,7z"
  }));
})).withConfig({
  displayName: "printer__CollecticonPrinter",
  componentId: "sc-1t5531d-0"
})([""]);

var CollecticonQuoteLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'quote left icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,3V1c-4.188,0-7,2.812-7,7v7h7V8h-5C11,4.916,12.916,3,16,3z M0,8v7h7V8H2c0-3.084,1.916-5,5-5V1C2.812,1,0,3.812,0,8z"
  }));
})).withConfig({
  displayName: "quote-left__CollecticonQuoteLeft",
  componentId: "sc-4aykvt-0"
})([""]);

var CollecticonQuoteRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'quote right icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,8h5c0,3.084-1.916,5-5,5v2c4.188,0,7-2.812,7-7V1H0V8z M9,1v7h5c0,3.084-1.916,5-5,5v2c4.188,0,7-2.812,7-7V1H9z"
  }));
})).withConfig({
  displayName: "quote-right__CollecticonQuoteRight",
  componentId: "sc-16q59gl-0"
})([""]);

var CollecticonResizeCenterHorizontal = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'resize center horizontal icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6.999,16h2.002V0H6.999V16z M5.414,5.414L4,4L0,8l4,4l1.414-1.414L3.828,9H6V7H3.828L5.414,5.414z M12,4l-1.414,1.414 L12.172,7H10v2h2.172l-1.586,1.586L12,12l4-4L12,4z"
  }));
})).withConfig({
  displayName: "resize-center-horizontal__CollecticonResizeCenterHorizontal",
  componentId: "sc-1uhrfmw-0"
})([""]);

var CollecticonResizeCenterVertical = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'resize center vertical icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.999v2.002h16V6.999H0z M7,3.828V6h2V3.828l1.586,1.586L12,4L8,0L4,4l1.414,1.414L7,3.828z M9,12.172V10H7v2.172 l-1.586-1.586L4,12l4,4l4-4l-1.414-1.414L9,12.172z"
  }));
})).withConfig({
  displayName: "resize-center-vertical__CollecticonResizeCenterVertical",
  componentId: "sc-17ttas-0"
})([""]);

var CollecticonResizeIn = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'resize in icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2,8L8,8L8,14L6,14L6,11.4L1.4,16L-0.014,14.586L4.572,10L2,10L2,8ZM8,2L10,2L10,4.6L14.6,0L16.014,1.414L11.428,6L14,6L14,8L8,8L8,2Z"
  }));
})).withConfig({
  displayName: "resize-in__CollecticonResizeIn",
  componentId: "sc-yqh48y-0"
})([""]);

var CollecticonResizeOut = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'resize out icon'), /*#__PURE__*/React.createElement("path", {
    d: "M1.986,12.6L6.586,8L8,9.414L3.414,14L5.986,14L5.986,16L1.986,16L-0.014,16L-0.014,10L1.986,10L1.986,12.6ZM12.586,2L10.014,2L10.014,0L16.014,0L16.014,6L14.014,6L14.014,3.4L9.414,8L8,6.586L12.586,2Z"
  }));
})).withConfig({
  displayName: "resize-out__CollecticonResizeOut",
  componentId: "sc-14snpdr-0"
})([""]);

var CollecticonRoad = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'road icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,16L13,0H9v1H7V0H3L0,16h7v-4h2v4H16z M7,3h2v2H7V3z M7,10V7h2v3H7z"
  }));
})).withConfig({
  displayName: "road__CollecticonRoad",
  componentId: "sc-kxef51-0"
})([""]);

var CollecticonRock = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'rock icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6.516,2.612L9.325,3.55l0.734,2.934l0.188,0.75l0.644,0.428l2.238,1.494L13.734,14H2.441l0.331-1.65l1.125-0.562 l0.875-0.438l0.191-0.959L6.516,2.612 M5,0L3,10l-2,1l-1,5h16l-1-8l-3-2l-1-4L5,0L5,0z"
  }));
})).withConfig({
  displayName: "rock__CollecticonRock",
  componentId: "sc-1m4dfhv-0"
})([""]);

var CollecticonRssFeed = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'rss feed icon'), /*#__PURE__*/React.createElement("path", {
    d: "M1,5v2c1.081,0,2.128,0.211,3.113,0.628c0.952,0.403,1.808,0.98,2.543,1.715s1.312,1.591,1.715,2.543 C8.789,12.872,9,13.919,9,15h2C11,9.477,6.523,5,1,5z M4,10c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S5.105,10,4,10z M1,1v2 c1.621,0,3.192,0.317,4.67,0.942c1.429,0.604,2.712,1.47,3.815,2.573c1.103,1.103,1.968,2.386,2.573,3.815 C12.683,11.808,13,13.379,13,15h2C15,7.268,8.732,1,1,1z"
  }));
})).withConfig({
  displayName: "rss-feed__CollecticonRssFeed",
  componentId: "sc-krf4ws-0"
})([""]);

var CollecticonShare2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'share 2 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,11c-0.609,0-1.169,0.219-1.603,0.581l-6.9-3.45C5,8.088,5,8.044,5,8c0-0.044,0-0.088-0.003-0.131l6.9-3.45 C12.331,4.781,12.891,5,13.5,5C14.881,5,16,3.881,16,2.5S14.881,0,13.5,0S11,1.119,11,2.5c0,0.044,0,0.088,0.003,0.131l-6.9,3.45 C3.669,5.719,3.109,5.5,2.5,5.5C1.119,5.5,0,6.619,0,8s1.119,2.5,2.5,2.5c0.609,0,1.169-0.219,1.603-0.581l6.9,3.45 C11,13.412,11,13.456,11,13.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S14.881,11,13.5,11z"
  }));
})).withConfig({
  displayName: "share-2__CollecticonShare2",
  componentId: "sc-2o6k8j-0"
})([""]);

var CollecticonShare = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'share icon'), /*#__PURE__*/React.createElement("path", {
    d: "M10,6v2h3v6H3V8h3V6H1v10h14V6H10z M7,3.328V11h2V3.328l1.834,1.834L12,4L8,0L4,4l1.166,1.166L7,3.328z"
  }));
})).withConfig({
  displayName: "share__CollecticonShare",
  componentId: "sc-ob5ay5-0"
})([""]);

var CollecticonShrinkToLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'shrink to left icon'), /*#__PURE__*/React.createElement("path", {
    id: "shrink-to-left",
    d: "M16,16L0,16L0,0L16,0L16,16ZM4,2L4,14L14,14L14,2L4,2ZM10.414,10.586L7.828,8L10.414,5.414L9,4L5,8L9,12L10.414,10.586Z"
  }));
})).withConfig({
  displayName: "shrink-to-left__CollecticonShrinkToLeft",
  componentId: "sc-tcmzh2-0"
})([""]);

var CollecticonShrinkToRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'shrink to right icon'), /*#__PURE__*/React.createElement("path", {
    id: "shrink-to-right",
    d: "M0,0L16,0L16,16L0,16L0,0ZM12,14L12,2L2,2L2,14L12,14ZM5.586,5.414L8.172,8L5.586,10.586L7,12L11,8L7,4L5.586,5.414Z"
  }));
})).withConfig({
  displayName: "shrink-to-right__CollecticonShrinkToRight",
  componentId: "sc-1fxnoaq-0"
})([""]);

var CollecticonSignDanger = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'sign danger icon'), /*#__PURE__*/React.createElement("path", {
    d: "M15.006,12.262L8.994,1.737c-0.547-0.956-1.438-0.956-1.984,0L0.994,12.262C0.447,13.219,0.9,14,2,14h12 C15.1,14,15.553,13.219,15.006,12.262z M8,13c-0.691,0-1.25-0.559-1.25-1.25c0-0.691,0.559-1.25,1.25-1.25 c0.691,0,1.25,0.559,1.25,1.25C9.25,12.441,8.691,13,8,13z M9,10H7V5h2V10z"
  }));
})).withConfig({
  displayName: "sign-danger__CollecticonSignDanger",
  componentId: "sc-1ecz7b4-0"
})([""]);

var CollecticonSlidersHorizontal = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'sliders horizontal icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,12H0v2h4v1h3v-4H4V12z M9,10h3V6H9v1H0v2h9V10z M3,5h3V1H3v1H0v2h3V5z M8,14h8v-2H8V14z M7,2v2h9V2H7z M13,9h3V7h-3V9z"
  }));
})).withConfig({
  displayName: "sliders-horizontal__CollecticonSlidersHorizontal",
  componentId: "sc-11z3834-0"
})([""]);

var CollecticonSlidersVertical = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'sliders vertical icon'), /*#__PURE__*/React.createElement("path", {
    d: "M12,12v4h2v-4h1V9h-4v3H12z M10,7V4H6v3h1v9h2V7H10z M5,13v-3H1v3h1v3h2v-3H5z M14,8V0h-2v8H14z M2,9h2V0H2V9z M9,3V0H7v3H9z"
  }));
})).withConfig({
  displayName: "sliders-vertical__CollecticonSlidersVertical",
  componentId: "sc-12f45x9-0"
})([""]);

var CollecticonSortAsc = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'sort asc icon'), /*#__PURE__*/React.createElement("g", {
    id: "sort-asc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-down",
    d: "M8.002,11.5l-3.294,-2.622l-1.416,1.416l4.71,3.706l4.706,-3.706l-1.416,-1.416l-3.29,2.622Z",
    opacity: "0.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-up",
    d: "M7.998,4.5l3.294,2.622l1.416,-1.416l-4.71,-3.706l-4.706,3.706l1.416,1.416l3.29,-2.622Z"
  })));
})).withConfig({
  displayName: "sort-asc__CollecticonSortAsc",
  componentId: "sc-1swvzh4-0"
})([""]);

var CollecticonSortDesc = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'sort desc icon'), /*#__PURE__*/React.createElement("g", {
    id: "sort-desc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-down",
    d: "M8.002,11.5l-3.294,-2.622l-1.416,1.416l4.71,3.706l4.706,-3.706l-1.416,-1.416l-3.29,2.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-up",
    d: "M7.998,4.5l3.294,2.622l1.416,-1.416l-4.71,-3.706l-4.706,3.706l1.416,1.416l3.29,-2.622Z",
    opacity: "0.32"
  })));
})).withConfig({
  displayName: "sort-desc__CollecticonSortDesc",
  componentId: "sc-1g5jihn-0"
})([""]);

var CollecticonSortNone = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'sort none icon'), /*#__PURE__*/React.createElement("path", {
    opacity: "0.32",
    d: "M8,11.5L4.706,8.878l-1.416,1.416L8,14l4.706-3.706l-1.416-1.416L8,11.5z M8,4.5l3.294,2.622l1.416-1.416L8,2L3.294,5.706 l1.416,1.416L8,4.5z"
  }));
})).withConfig({
  displayName: "sort-none__CollecticonSortNone",
  componentId: "sc-u7zsfg-0"
})([""]);

var CollecticonSort = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'sort icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,11.5L4.706,8.878l-1.416,1.416L8,14l4.706-3.706l-1.416-1.416L8,11.5z M8,4.5l3.294,2.622l1.416-1.416L8,2L3.294,5.706 l1.416,1.416L8,4.5z"
  }));
})).withConfig({
  displayName: "sort__CollecticonSort",
  componentId: "sc-dgizvs-0"
})([""]);

var CollecticonSpark = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'spark icon'), /*#__PURE__*/React.createElement("path", {
    d: "M10,1L3,9h4.5L6,15l7-8H8.5L10,1z"
  }));
})).withConfig({
  displayName: "spark__CollecticonSpark",
  componentId: "sc-bhnjlj-0"
})([""]);

var CollecticonSpeechBalloon = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'speech balloon icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4,13L2,13C1.47,13 0.961,12.789 0.586,12.414C0.211,12.039 0,11.53 0,11C0,9.257 0,6.743 0,5C0,4.47 0.211,3.961 0.586,3.586C0.961,3.211 1.47,3 2,3C5.074,3 10.926,3 14,3C14.53,3 15.039,3.211 15.414,3.586C15.789,3.961 16,4.47 16,5C16,6.743 16,9.257 16,11C16,11.53 15.789,12.039 15.414,12.414C15.039,12.789 14.53,13 14,13L8,13L4,16L4,13Z"
  }));
})).withConfig({
  displayName: "speech-balloon__CollecticonSpeechBalloon",
  componentId: "sc-13d2rgy-0"
})([""]);

var CollecticonSquareSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'square small icon'), /*#__PURE__*/React.createElement("rect", {
    x: "4",
    y: "4",
    width: "8",
    height: "8"
  }));
})).withConfig({
  displayName: "square--small__CollecticonSquareSmall",
  componentId: "sc-tacoml-0"
})([""]);

var CollecticonSquare = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'square icon'), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "2",
    width: "12",
    height: "12"
  }));
})).withConfig({
  displayName: "square__CollecticonSquare",
  componentId: "sc-f9q5rr-0"
})([""]);

var CollecticonStar = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'star icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,6.204l-5.528-0.803L8,0.392L5.528,5.401L0,6.204l4,3.899l-0.944,5.505L8,13.009l4.944,2.599L12,10.103L16,6.204z"
  }));
})).withConfig({
  displayName: "star__CollecticonStar",
  componentId: "sc-1y1tcee-0"
})([""]);

var CollecticonSteam = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'steam icon'), /*#__PURE__*/React.createElement("path", {
    d: "M7,16h2v-6H7V16z M12.603,3.044C11.844,1.256,10.069,0,8,0C5.238,0,3,2.237,3,5C1.344,5,0,6.344,0,8s1.344,3,3,3h0.284L4,15 h2L5,9H3C2.45,9,2,8.55,2,8s0.45-1,1-1h2V5c0-1.653,1.347-3,3-3c1.206,0,2.291,0.719,2.762,1.828L11.2,4.856l1.103,0.166 c0.466,0.072,0.897,0.306,1.209,0.669C13.734,5.947,14,6.381,14,7c0,1.103-0.897,2-2,2h-1l-1,6h2l0.725-4.066 C14.587,10.594,16,8.962,16,7C16,4.997,14.525,3.338,12.603,3.044z"
  }));
})).withConfig({
  displayName: "steam__CollecticonSteam",
  componentId: "sc-1yiviod-0"
})([""]);

var CollecticonSubscript2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'subscript 2 icon'), /*#__PURE__*/React.createElement("path", {
    id: "subscript",
    d: "M13,12l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Zm-1,3l-2,0l0,-5l-6,0l0,5l-2,0l0,-9c0,-2.76 2.24,-5 5,-5c2.76,0 5,2.24 5,5l0,9Zm-2,-7l0,-2c0,-1.656 -1.344,-3 -3,-3c-1.656,0 -3,1.344 -3,3l0,2l6,0Z"
  }));
})).withConfig({
  displayName: "subscript-2__CollecticonSubscript2",
  componentId: "sc-c9wj65-0"
})([""]);

var CollecticonSubscript = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'subscript icon'), /*#__PURE__*/React.createElement("path", {
    d: "M13,12l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Zm-4.586,-4l4,4l-2.828,0l-2.586,-2.586l-2.586,2.586l-2.828,0l4,-4l-4,-4l2.828,0l2.586,2.586l2.586,-2.586l2.828,0l-4,4Z"
  }));
})).withConfig({
  displayName: "subscript__CollecticonSubscript",
  componentId: "sc-10v17n7-0"
})([""]);

var CollecticonSuperscript2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'superscript 2 icon'), /*#__PURE__*/React.createElement("path", {
    id: "superscript",
    d: "M12,15l-2,0l0,-5l-6,0l0,5l-2,0l0,-9c0,-2.76 2.24,-5 5,-5c2.76,0 5,2.24 5,5l0,9Zm-2,-7l0,-2c0,-1.656 -1.344,-3 -3,-3c-1.656,0 -3,1.344 -3,3l0,2l6,0Zm3,-7l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Z"
  }));
})).withConfig({
  displayName: "superscript-2__CollecticonSuperscript2",
  componentId: "sc-1p3lqd0-0"
})([""]);

var CollecticonSuperscript = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'superscript icon'), /*#__PURE__*/React.createElement("path", {
    id: "superscript",
    d: "M8.414,8l4,4l-2.828,0l-2.586,-2.586l-2.586,2.586l-2.828,0l4,-4l-4,-4l2.828,0l2.586,2.586l2.586,-2.586l2.828,0l-4,4Zm4.586,-7l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Z"
  }));
})).withConfig({
  displayName: "superscript__CollecticonSuperscript",
  componentId: "sc-1wli6ww-0"
})([""]);

var CollecticonSwapHorizontal = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'swap horizontal icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,11h11.2l-2.6,2.6L10,15l6-6H0V11z M4.8,5l2.6-2.6L6,1L0,7h16V5H4.8z"
  }));
})).withConfig({
  displayName: "swap-horizontal__CollecticonSwapHorizontal",
  componentId: "sc-11czhsy-0"
})([""]);

var CollecticonSwapVertical = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'swap vertical icon'), /*#__PURE__*/React.createElement("path", {
    d: "M5,16L5,4.8L2.4,7.4L1,6L7,0L7,16L5,16ZM11,11.2L13.6,8.6L15,10L9,16L9,0L11,0L11,11.2Z"
  }));
})).withConfig({
  displayName: "swap-vertical__CollecticonSwapVertical",
  componentId: "sc-1b5kgbc-0"
})([""]);

var CollecticonTableAddColumn = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'table add column icon'), /*#__PURE__*/React.createElement("path", {
    id: "table-add-column",
    d: "M12,11l-0,2l2,0l-0,-2l2,0l-0,-2l-2,0l-0,-2l-2,0l-0,2l-2,0l-0,2l2,0Zm2,-5l-0,-5c0,-0.265 -0.105,-0.52 -0.293,-0.707c-0.187,-0.188 -0.442,-0.293 -0.707,-0.293l-10,-0c-0.552,-0 -1,0.448 -1,1c-0,2.577 -0,11.423 0,14c0,0.552 0.448,1 1,1c1.916,0 8.084,0 10,0c0.552,-0 1,-0.448 1,-1l-0,-1l-5,0l-0,-12l3,0l-0,4l2,0Zm-10,-4l3,0l-0,12l-3,0l-0,-12Z"
  }));
})).withConfig({
  displayName: "table-add-column__CollecticonTableAddColumn",
  componentId: "sc-1v902ed-0"
})([""]);

var CollecticonTableAddRow = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'table add row icon'), /*#__PURE__*/React.createElement("path", {
    id: "table-add-row",
    d: "M11,12l2,0l0,2l-2,0l0,2l-2,0l0,-2l-2,0l0,-2l2,0l0,-2l2,0l0,2Zm-5,2l-5,-0c-0.265,0 -0.52,-0.105 -0.707,-0.293c-0.188,-0.187 -0.293,-0.442 -0.293,-0.707l-0,-10c-0,-0.552 0.448,-1 1,-1c2.577,0 11.423,-0 14,0c0.552,0 1,0.448 1,1c-0,1.916 0,8.084 -0,10c-0,0.552 -0.448,1 -1,1l-1,-0l0,-5l-12,-0l0,3l4,0l0,2Zm-4,-10l0,3l12,0l0,-3l-12,0Z"
  }));
})).withConfig({
  displayName: "table-add-row__CollecticonTableAddRow",
  componentId: "sc-633nv5-0"
})([""]);

var CollecticonTableSubtractColumn = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'table subtract column icon'), /*#__PURE__*/React.createElement("path", {
    id: "table-subtract-column",
    d: "M11.414,13l1.586,-1.586l1.586,1.586l1.414,-1.414l-1.586,-1.586l1.586,-1.586l-1.414,-1.414l-1.586,1.586l-1.586,-1.586l-1.414,1.414l1.586,1.586l-1.586,1.586l1.414,1.414Zm2.586,-7l-0,-5c0,-0.265 -0.105,-0.52 -0.293,-0.707c-0.187,-0.188 -0.442,-0.293 -0.707,-0.293l-10,-0c-0.552,-0 -1,0.448 -1,1c-0,2.577 -0,11.423 0,14c0,0.552 0.448,1 1,1c1.916,0 8.084,0 10,0c0.552,-0 1,-0.448 1,-1l-0,-1l-5,0l-0,-12l3,0l-0,4l2,0Zm-10,-4l3,0l-0,12l-3,0l-0,-12Z"
  }));
})).withConfig({
  displayName: "table-subtract-column__CollecticonTableSubtractColumn",
  componentId: "sc-1fyh4v8-0"
})([""]);

var CollecticonTableSubtractRow = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'table subtract row icon'), /*#__PURE__*/React.createElement("path", {
    id: "table-subtract-row",
    d: "M13,11.414l-1.586,1.586l1.586,1.586l-1.414,1.414l-1.586,-1.586l-1.586,1.586l-1.414,-1.414l1.586,-1.586l-1.586,-1.586l1.414,-1.414l1.586,1.586l1.586,-1.586l1.414,1.414Zm-7,2.586l-5,-0c-0.265,0 -0.52,-0.105 -0.707,-0.293c-0.188,-0.187 -0.293,-0.442 -0.293,-0.707l-0,-10c-0,-0.552 0.448,-1 1,-1c2.577,0 11.423,-0 14,0c0.552,0 1,0.448 1,1c-0,1.916 0,8.084 -0,10c-0,0.552 -0.448,1 -1,1l-1,-0l0,-5l-12,-0l0,3l4,0l0,2Zm-4,-10l0,3l12,0l0,-3l-12,0Z"
  }));
})).withConfig({
  displayName: "table-subtract-row__CollecticonTableSubtractRow",
  componentId: "sc-m6hsld-0"
})([""]);

var CollecticonTable = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'table icon'), /*#__PURE__*/React.createElement("path", {
    d: "M1,16C0.448,16 0,15.552 0,15C0,12.127 0,3.873 0,1C0,0.448 0.448,0 1,0C3.873,0 12.127,0 15,0C15.552,0 16,0.448 16,1C16,3.873 16,12.127 16,15C16,15.552 15.552,16 15,16C12.127,16 3.873,16 1,16ZM2,7L2,14L4,14L4,7L2,7ZM6,7L6,14L10,14L10,7L6,7ZM12,7L12,14L14,14L14,7L12,7ZM2,2L2,5L14,5L14,2L2,2Z"
  }));
})).withConfig({
  displayName: "table__CollecticonTable",
  componentId: "sc-1ck2wmp-0"
})([""]);

var CollecticonTag = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'tag icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14.497,0H9.988C9.162,0,8.007,0.478,7.423,1.063L0.438,8.047c-0.585,0.585-0.585,1.541,0,2.125l5.389,5.389 c0.584,0.585,1.541,0.585,2.125,0l6.984-6.984C15.522,7.993,16,6.838,16,6.012V1.503C16,0.676,15.324,0,14.497,0z M12.5,5 C11.672,5,11,4.328,11,3.5S11.672,2,12.5,2S14,2.672,14,3.5S13.328,5,12.5,5z"
  }));
})).withConfig({
  displayName: "tag__CollecticonTag",
  componentId: "sc-kmqdpo-0"
})([""]);

var CollecticonTarget = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'target icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10.5c-1.378,0-2.5-1.122-2.5-2.5S6.622,5.5,8,5.5 s2.5,1.122,2.5,2.5S9.378,10.5,8,10.5z M8,7C7.447,7,7,7.447,7,8s0.447,1,1,1s1-0.447,1-1S8.553,7,8,7z M8,0C3.581,0,0,3.581,0,8 s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756 C2.622,11.112,2,9.603,2,8s0.625-3.109,1.756-4.244C4.888,2.622,6.397,2,8,2s3.109,0.625,4.244,1.756C13.378,4.888,14,6.397,14,8 S13.375,11.109,12.244,12.244z"
  }));
})).withConfig({
  displayName: "target__CollecticonTarget",
  componentId: "sc-o9hlvz-0"
})([""]);

var CollecticonTextBlock = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'text block icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,10h16V8H0V10z M0,0v2h16V0H0z M0,14h8v-2H0V14z M0,6h16V4H0V6z"
  }));
})).withConfig({
  displayName: "text-block__CollecticonTextBlock",
  componentId: "sc-xb76he-0"
})([""]);

var CollecticonTickSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'tick small icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2,9.014L3.414,7.6L6.004,10.189L12.593,3.6L14.007,5.014L6.003,13.017L2,9.014Z"
  }));
})).withConfig({
  displayName: "tick--small__CollecticonTickSmall",
  componentId: "sc-1gw1pv0-0"
})([""]);

var CollecticonTick = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'tick icon'), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.014L1.414,7.6L5.004,11.189L14.593,1.6L16.007,3.014L5.003,14.017L0,9.014Z"
  }));
})).withConfig({
  displayName: "tick__CollecticonTick",
  componentId: "sc-kz2lfw-0"
})([""]);

var CollecticonTrashBin = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'trash bin icon'), /*#__PURE__*/React.createElement("path", {
    d: "M11,5h2v8.5c0,0.825-0.675,1.5-1.5,1.5h-7C3.675,15,3,14.325,3,13.5V5h2v8h2V5h2v8h2V5z M2,2h12v2H2V2z M6,0h4v1H6V0z"
  }));
})).withConfig({
  displayName: "trash-bin__CollecticonTrashBin",
  componentId: "sc-1md69fn-0"
})([""]);

var CollecticonTriangleDownSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle down small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "8,11 3,6 13,6"
  }));
})).withConfig({
  displayName: "triangle-down--small__CollecticonTriangleDownSmall",
  componentId: "sc-1mvvmvk-0"
})([""]);

var CollecticonTriangleDown = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle down icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "8,13 0,5 16,5"
  }));
})).withConfig({
  displayName: "triangle-down__CollecticonTriangleDown",
  componentId: "sc-yiau6v-0"
})([""]);

var CollecticonTriangleLeftSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle left small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "5,8 10,3 10,13"
  }));
})).withConfig({
  displayName: "triangle-left--small__CollecticonTriangleLeftSmall",
  componentId: "sc-1wii1zs-0"
})([""]);

var CollecticonTriangleLeft = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle left icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "3,8 11,0 11,16"
  }));
})).withConfig({
  displayName: "triangle-left__CollecticonTriangleLeft",
  componentId: "sc-15tp8d3-0"
})([""]);

var CollecticonTriangleRightSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle right small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "11,8 6,13 6,3"
  }));
})).withConfig({
  displayName: "triangle-right--small__CollecticonTriangleRightSmall",
  componentId: "sc-f8t04i-0"
})([""]);

var CollecticonTriangleRight = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle right icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "13,8 5,16 5,0"
  }));
})).withConfig({
  displayName: "triangle-right__CollecticonTriangleRight",
  componentId: "sc-nu28g8-0"
})([""]);

var CollecticonTriangleUpSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle up small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "8,5 13,10 3,10"
  }));
})).withConfig({
  displayName: "triangle-up--small__CollecticonTriangleUpSmall",
  componentId: "sc-19tjeu7-0"
})([""]);

var CollecticonTriangleUp = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'triangle up icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "8,3 16,11 0,11"
  }));
})).withConfig({
  displayName: "triangle-up__CollecticonTriangleUp",
  componentId: "sc-iwnypi-0"
})([""]);

var CollecticonTumblrReblog = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'tumblr reblog icon'), /*#__PURE__*/React.createElement("path", {
    d: "M2,5h10.672l-1.837,1.834L12,8l4-4l-4-4l-1.166,1.166L12.672,3H0v7l2-2V5z M14,11H3.328l1.838-1.834L4,8l-4,4l4,4 l1.166-1.166L3.328,13H16V6l-2,2V11z"
  }));
})).withConfig({
  displayName: "tumblr-reblog__CollecticonTumblrReblog",
  componentId: "sc-53971o-0"
})([""]);

var CollecticonUfo = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'ufo icon'), /*#__PURE__*/React.createElement("path", {
    d: "M6,13L3,15L3.889,12.333L0,10L16,10L12.111,12.333L13,15L10,13L6,13ZM16,9L0,9L0,8L3,6C3,3.24 5.24,1 8,1C10.76,1 13,3.24 13,6L16,8L16,9Z"
  }));
})).withConfig({
  displayName: "ufo__CollecticonUfo",
  componentId: "sc-19wp69f-0"
})([""]);

var CollecticonUnderline = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'underline icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3,13l10,0l0,2l-10,0l0,-2Zm8,-12l2,0l0,6c0,2.76 -2.24,5 -5,5c-2.76,0 -5,-2.24 -5,-5l0,-6l2,0l-0,6c-0,1.656 1.344,3 3,3c1.656,0 3,-1.344 3,-3l0,-6Z"
  }));
})).withConfig({
  displayName: "underline__CollecticonUnderline",
  componentId: "sc-1rup4pw-0"
})([""]);

var CollecticonUpload2 = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'upload 2 icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3.294,7.706l1.416,1.416L7,6.828V16h2V6.828l2.294,2.294l1.416-1.416L8,3L3.294,7.706z M0,2h16V0H0V2z"
  }));
})).withConfig({
  displayName: "upload-2__CollecticonUpload2",
  componentId: "sc-p2a7et-0"
})([""]);

var CollecticonUpload = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'upload icon'), /*#__PURE__*/React.createElement("path", {
    d: "M3.294,7.706l1.416,1.416L7,6.828V16h2V6.828l2.294,2.294l1.416-1.416L8,3L3.294,7.706z M2,12V2h12v10h2V0H0v12H2z"
  }));
})).withConfig({
  displayName: "upload__CollecticonUpload",
  componentId: "sc-1ww7u5j-0"
})([""]);

var CollecticonUserGroup = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'user group icon'), /*#__PURE__*/React.createElement("path", {
    d: "M14,12.5C14,11.837 13.737,11.201 13.268,10.732C12.799,10.263 12.163,10 11.5,10C9.447,10 6.553,10 4.5,10C3.837,10 3.201,10.263 2.732,10.732C2.263,11.201 2,11.837 2,12.5C2,14.147 2,15 2,15L14,15C14,15 14,14.147 14,12.5ZM12,6L14,6C14.53,6 15.039,6.211 15.414,6.586C15.789,6.961 16,7.47 16,8L16,11L14.663,11C14.101,9.818 12.896,9 11.5,9L10.645,9C11.476,8.267 12,7.194 12,6ZM1.337,11L0,11C0,11 0,9.392 0,8C0,7.47 0.211,6.961 0.586,6.586C0.961,6.211 1.47,6 2,6L4,6C4,7.194 4.524,8.267 5.355,9L4.5,9C3.104,9 1.899,9.817 1.337,11ZM8,3C9.656,3 11,4.344 11,6C11,7.656 9.656,9 8,9C6.344,9 5,7.656 5,6C5,4.344 6.344,3 8,3ZM4.127,4.996C4.085,4.999 4.043,5 4,5C2.896,5 2,4.104 2,3C2,1.896 2.896,1 4,1C4.954,1 5.753,1.67 5.952,2.564C5.061,3.097 4.394,3.966 4.127,4.996ZM10.048,2.564C10.247,1.67 11.046,1 12,1C13.104,1 14,1.896 14,3C14,4.104 13.104,5 12,5C11.957,5 11.915,4.999 11.873,4.996C11.606,3.966 10.939,3.097 10.048,2.564Z"
  }));
})).withConfig({
  displayName: "user-group__CollecticonUserGroup",
  componentId: "sc-1o3ubat-0"
})([""]);

var CollecticonUser = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'user icon'), /*#__PURE__*/React.createElement("path", {
    d: "M8,8c2.209,0,4-1.791,4-4s-1.791-4-4-4S4,1.791,4,4S5.791,8,8,8z M12,10H4c-2.209,0-4,1.791-4,4v2h16v-2 C16,11.791,14.209,10,12,10z"
  }));
})).withConfig({
  displayName: "user__CollecticonUser",
  componentId: "sc-jgwre8-0"
})([""]);

var CollecticonUsers = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'users icon'), /*#__PURE__*/React.createElement("path", {
    d: "M16,12.5C16,11.837 15.737,11.201 15.268,10.732C14.799,10.263 14.163,10 13.5,10C11.447,10 8.553,10 6.5,10C5.837,10 5.201,10.263 4.732,10.732C4.263,11.201 4,11.837 4,12.5C4,14.147 4,15 4,15L16,15C16,15 16,14.147 16,12.5ZM3,13L0,13C0,13 0,12.147 0,10.5C0,9.837 0.263,9.201 0.732,8.732C1.201,8.263 1.837,8 2.5,8L6.536,8C6.754,8.376 7.031,8.714 7.355,9L6.5,9C4.567,9 3,10.567 3,12.5L3,13ZM10,3C11.656,3 13,4.344 13,6C13,7.656 11.656,9 10,9C8.344,9 7,7.656 7,6C7,4.344 8.344,3 10,3ZM6.126,6.997C6.084,6.999 6.042,7 6,7C4.344,7 3,5.656 3,4C3,2.344 4.344,1 6,1C7.026,1 7.932,1.516 8.473,2.302C7.022,2.903 6,4.333 6,6C6,6.344 6.044,6.679 6.126,6.997Z"
  }));
})).withConfig({
  displayName: "users__CollecticonUsers",
  componentId: "sc-1543no2-0"
})([""]);

var CollecticonWay = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'way icon'), /*#__PURE__*/React.createElement("path", {
    d: "M15,3L15,4.268C15.598,4.614 16,5.26 16,6C16,7.104 15.104,8 14,8C12.896,8 12,7.104 12,6C12,5.26 12.402,4.614 13,4.268L13,3.5C13,2.672 12.328,2 11.5,2C10.672,2 10,2.672 10,3.5L10,12L10,12.013C9.993,14.215 8.203,16 6,16C3.792,16 2,14.208 2,12L2,11.829C0.835,11.417 0,10.305 0,9C0,7.344 1.344,6 3,6C4.656,6 6,7.344 6,9C6,10.305 5.165,11.417 4,11.829L4,12.006C4,12.108 4.008,12.21 4.024,12.311C4.049,12.471 4.094,12.629 4.157,12.778C4.254,13.008 4.395,13.219 4.569,13.397C4.736,13.568 4.933,13.709 5.15,13.81C5.336,13.898 5.535,13.957 5.739,13.983C5.958,14.012 6.181,14.004 6.397,13.961C6.583,13.923 6.764,13.859 6.932,13.77C7.13,13.665 7.311,13.527 7.464,13.362C7.615,13.2 7.738,13.014 7.828,12.812C7.898,12.654 7.948,12.487 7.975,12.317C7.992,12.212 8,12.106 8,12L8,3.5C8,1.568 9.568,0 11.5,0C13.262,0 14.721,1.305 14.964,3L15,3ZM3,8C2.448,8 2,8.448 2,9C2,9.552 2.448,10 3,10C3.552,10 4,9.552 4,9C4,8.448 3.552,8 3,8Z"
  }));
})).withConfig({
  displayName: "way__CollecticonWay",
  componentId: "sc-1ws2bod-0"
})([""]);

var CollecticonWrench = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'wrench icon'), /*#__PURE__*/React.createElement("path", {
    d: "M15.379,12.379L8.79,5.79C8.913,5.379,9,4.951,9,4.5C9,2.015,6.985,0,4.5,0C4.049,0,3.621,0.087,3.21,0.21l2.291,2.291 c0.828,0.828,0.828,2.17,0,2.998L5.499,5.501c-0.828,0.828-2.17,0.828-2.998,0L0.21,3.21C0.087,3.621,0,4.049,0,4.5 C0,6.985,2.015,9,4.5,9c0.451,0,0.879-0.087,1.29-0.21l6.589,6.589c0.828,0.828,2.17,0.828,2.998,0l0.002-0.002 C16.207,14.549,16.207,13.207,15.379,12.379z M13.75,14.75c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S14.302,14.75,13.75,14.75z"
  }));
})).withConfig({
  displayName: "wrench__CollecticonWrench",
  componentId: "sc-13hjr0s-0"
})([""]);

var CollecticonXmarkSmall = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'xmark small icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "13.707,3.707 12.293,2.293 8,6.586 3.707,2.293 2.293,3.707 6.586,8 2.293,12.293 3.707,13.707 8,9.414  12.293,13.707 13.707,12.293 9.414,8"
  }));
})).withConfig({
  displayName: "xmark--small__CollecticonXmarkSmall",
  componentId: "sc-194sjhs-0"
})([""]);

var CollecticonXmark = /*#__PURE__*/styled(createCollecticon(function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, props.title || 'xmark icon'), /*#__PURE__*/React.createElement("polygon", {
    points: "14.707,2.707 13.293,1.293 8,6.586 2.707,1.293 1.293,2.707 6.586,8 1.293,13.293 2.707,14.707 8,9.414 13.293,14.707 14.707,13.293 9.414,8"
  }));
})).withConfig({
  displayName: "xmark__CollecticonXmark",
  componentId: "sc-pn541c-0"
})([""]);

export { CollecticonArea, CollecticonArrowDown, CollecticonArrowDownLeft, CollecticonArrowDownRight, CollecticonArrowLeft, CollecticonArrowLoop, CollecticonArrowMove, CollecticonArrowReply, CollecticonArrowReturn, CollecticonArrowRevert, CollecticonArrowRight, CollecticonArrowSemiSpinCcw, CollecticonArrowSemiSpinCw, CollecticonArrowSpinCcw, CollecticonArrowSpinCw, CollecticonArrowUp, CollecticonArrowUpLeft, CollecticonArrowUpRight, CollecticonBell, CollecticonBlow, CollecticonBold, CollecticonBook, CollecticonBookBookmark, CollecticonBrandCollecticons, CollecticonBrandDevelopmentSeed, CollecticonBrandDevelopmentSeed2, CollecticonBrandDropbox, CollecticonBrandFacebook, CollecticonBrandFlickr, CollecticonBrandGithub, CollecticonBrandHumanRights, CollecticonBrandId, CollecticonBrandInstagram, CollecticonBrandLastfm, CollecticonBrandLinkedin, CollecticonBrandMedium, CollecticonBrandSatsummit, CollecticonBrandSkype, CollecticonBrandSlack, CollecticonBrandSoundcloud, CollecticonBrandTumblr, CollecticonBrandTwitter, CollecticonBrandYoutube, CollecticonBriefcase, CollecticonCalendar, CollecticonCalendarRange, CollecticonCalendarSlot, CollecticonCamera, CollecticonChartBars, CollecticonChartLine, CollecticonChartPie, CollecticonChevronDown, CollecticonChevronDownSmall, CollecticonChevronDownTrailSmall, CollecticonChevronLeft, CollecticonChevronLeftSmall, CollecticonChevronLeftTrailSmall, CollecticonChevronRight, CollecticonChevronRightSmall, CollecticonChevronRightTrailSmall, CollecticonChevronStepBackward, CollecticonChevronStepForward, CollecticonChevronUp, CollecticonChevronUpSmall, CollecticonChevronUpTrailSmall, CollecticonCircleExclamation, CollecticonCircleForbidden, CollecticonCircleInformation, CollecticonCirclePause, CollecticonCirclePlay, CollecticonCirclePlayNext, CollecticonCircleQuestion, CollecticonCircleRecord, CollecticonCircleStop, CollecticonCircleTick, CollecticonCircleXmark, CollecticonClipboard, CollecticonClipboardTick, CollecticonClock, CollecticonClockBack, CollecticonCode, CollecticonCog, CollecticonCompass, CollecticonCompass2, CollecticonCrosshair, CollecticonCrosshair2, CollecticonDiscDollar, CollecticonDiscXmark, CollecticonDownload, CollecticonDownload2, CollecticonDrop, CollecticonEllipsisHorizontal, CollecticonEllipsisVertical, CollecticonEnvelope, CollecticonEqual, CollecticonEqualSmall, CollecticonExclamationSmall, CollecticonExpandCollapse, CollecticonExpandDownLeft, CollecticonExpandDownRight, CollecticonExpandFromLeft, CollecticonExpandFromRight, CollecticonExpandTopLeft, CollecticonExpandTopRight, CollecticonEye, CollecticonEyeDisabled, CollecticonFaceHappy, CollecticonFaceSad, CollecticonFactory, CollecticonFence, CollecticonFilter, CollecticonFlagPole, CollecticonFlame, CollecticonFolder, CollecticonGauge, CollecticonGitFork, CollecticonGlobe, CollecticonGripHorizontal, CollecticonGripVertical, CollecticonHamburgerMenu, CollecticonHandPan, CollecticonHandSwipeHorizontal, CollecticonHandThumbsDown, CollecticonHandThumbsUp, CollecticonHeading, CollecticonHeart, CollecticonHouse, CollecticonHouses, CollecticonIsoStack, CollecticonItalic, CollecticonKeyboard, CollecticonLayoutColumn2x, CollecticonLayoutGrid2x2, CollecticonLayoutGrid3x3, CollecticonLayoutRow2x, CollecticonLeaf, CollecticonLink, CollecticonList, CollecticonListNumbered, CollecticonLock, CollecticonLock2, CollecticonLock2Open, CollecticonLockOpen, CollecticonLogin, CollecticonLogout, CollecticonMagnifierLeft, CollecticonMagnifierRight, CollecticonMap, CollecticonMarker, CollecticonMinus, CollecticonMinusSmall, CollecticonMobilePhone, CollecticonOptionsTick, CollecticonPage, CollecticonPageCog, CollecticonPageLabel, CollecticonPageLockOpen, CollecticonPageTick, CollecticonPageUp, CollecticonPages, CollecticonPencil, CollecticonPi, CollecticonPicture, CollecticonPilcrow, CollecticonPlus, CollecticonPlusSmall, CollecticonPopDown, CollecticonPopUp, CollecticonPrinter, CollecticonQuoteLeft, CollecticonQuoteRight, CollecticonResizeCenterHorizontal, CollecticonResizeCenterVertical, CollecticonResizeIn, CollecticonResizeOut, CollecticonRoad, CollecticonRock, CollecticonRssFeed, CollecticonShare, CollecticonShare2, CollecticonShrinkToLeft, CollecticonShrinkToRight, CollecticonSignDanger, CollecticonSlidersHorizontal, CollecticonSlidersVertical, CollecticonSort, CollecticonSortAsc, CollecticonSortDesc, CollecticonSortNone, CollecticonSpark, CollecticonSpeechBalloon, CollecticonSquare, CollecticonSquareSmall, CollecticonStar, CollecticonSteam, CollecticonSubscript, CollecticonSubscript2, CollecticonSuperscript, CollecticonSuperscript2, CollecticonSwapHorizontal, CollecticonSwapVertical, CollecticonTable, CollecticonTableAddColumn, CollecticonTableAddRow, CollecticonTableSubtractColumn, CollecticonTableSubtractRow, CollecticonTag, CollecticonTarget, CollecticonTextBlock, CollecticonTick, CollecticonTickSmall, CollecticonTrashBin, CollecticonTriangleDown, CollecticonTriangleDownSmall, CollecticonTriangleLeft, CollecticonTriangleLeftSmall, CollecticonTriangleRight, CollecticonTriangleRightSmall, CollecticonTriangleUp, CollecticonTriangleUpSmall, CollecticonTumblrReblog, CollecticonUfo, CollecticonUnderline, CollecticonUpload, CollecticonUpload2, CollecticonUser, CollecticonUserGroup, CollecticonUsers, CollecticonWay, CollecticonWrench, CollecticonXmark, CollecticonXmarkSmall, createCollecticon, iconDataURI };
//# sourceMappingURL=index.es.js.map
